[
  {
    "fn": "createASpikeProtectionNotificationAction",
    "method": "POST",
    "path": "/api/0/organizations/{organization_id_or_slug}/notifications/actions/",
    "description": "Creates a new Notification Action for Spike Protection.\n\nNotification Actions notify a set of members when an action has been triggered through a notification service such as Slack or Sentry.\nFor example, organization owners and managers can receive an email when a spike occurs.",
    "pathParams": [
      "organization_id_or_slug"
    ],
    "queryParams": [],
    "deprecated": false,
    "resource": "actions",
    "operationId": "Create a Spike Protection Notification Action"
  },
  {
    "fn": "deleteASpikeProtectionNotificationAction",
    "method": "DELETE",
    "path": "/api/0/organizations/{organization_id_or_slug}/notifications/actions/{action_id}/",
    "description": "Deletes a Spike Protection Notification Action.\n\nNotification Actions notify a set of members when an action has been triggered through a notification service such as Slack or Sentry.\nFor example, organization owners and managers can receive an email when a spike occurs.",
    "pathParams": [
      "organization_id_or_slug",
      "action_id"
    ],
    "queryParams": [],
    "deprecated": false,
    "resource": "actions",
    "operationId": "Delete a Spike Protection Notification Action"
  },
  {
    "fn": "listSpikeProtectionNotifications",
    "method": "GET",
    "path": "/api/0/organizations/{organization_id_or_slug}/notifications/actions/",
    "description": "Returns all Spike Protection Notification Actions for an organization.\n\nNotification Actions notify a set of members when an action has been triggered through a notification service such as Slack or Sentry.\nFor example, organization owners and managers can receive an email when a spike occurs.\n\nYou can use either the `project` or `projectSlug` query parameter to filter for certain projects. Note that if both are present, `projectSlug` takes priority.",
    "pathParams": [
      "organization_id_or_slug"
    ],
    "queryParams": [
      "project",
      "project_id_or_slug",
      "triggerType"
    ],
    "deprecated": false,
    "resource": "actions",
    "operationId": "List Spike Protection Notifications"
  },
  {
    "fn": "retrieveASpikeProtectionNotificationAction",
    "method": "GET",
    "path": "/api/0/organizations/{organization_id_or_slug}/notifications/actions/{action_id}/",
    "description": "Returns a serialized Spike Protection Notification Action object.\n\nNotification Actions notify a set of members when an action has been triggered through a notification service such as Slack or Sentry.\nFor example, organization owners and managers can receive an email when a spike occurs.",
    "pathParams": [
      "organization_id_or_slug",
      "action_id"
    ],
    "queryParams": [],
    "deprecated": false,
    "resource": "actions",
    "operationId": "Retrieve a Spike Protection Notification Action"
  },
  {
    "fn": "updateASpikeProtectionNotificationAction",
    "method": "PUT",
    "path": "/api/0/organizations/{organization_id_or_slug}/notifications/actions/{action_id}/",
    "description": "Updates a Spike Protection Notification Action.\n\nNotification Actions notify a set of members when an action has been triggered through a notification service such as Slack or Sentry.\nFor example, organization owners and managers can receive an email when a spike occurs.",
    "pathParams": [
      "organization_id_or_slug",
      "action_id"
    ],
    "queryParams": [],
    "deprecated": false,
    "resource": "actions",
    "operationId": "Update a Spike Protection Notification Action"
  },
  {
    "fn": "deprecatedCreateAMetricAlertRuleForAnOrganization",
    "method": "POST",
    "path": "/api/0/organizations/{organization_id_or_slug}/alert-rules/",
    "description": "## Deprecated\n🚧 Use [Create a Monitor for a Project](/api/monitors/create-a-monitor-for-a-project) and [Create an Alert for an Organization](/api/monitors/create-an-alert-for-an-organization) instead.\n\n\nCreate a new metric alert rule for the given organization.\n\nA metric alert rule is a configuration that defines the conditions for triggering an alert.\nIt specifies the metric type, function, time interval, and threshold\nvalues that determine when an alert should be triggered. Metric alert rules are used to monitor\nand notify you when certain metrics, like error count, latency, or failure rate, cross a\npredefined threshold. These rules help you proactively identify and address issues in your\nproject.\n\n## Metric Alert Rule Types\nBelow are the types of metric alert rules you can create and the parameter values required\nto set them up. All other parameters can be customized based on how you want the alert\nrule to work. Scroll down to Body Parameters for more information. Visit the\n[Alert Types](/product/alerts/alert-types/#metric-alerts) docs for more details on each\nmetric alert rule type.\n\n### [Number of Errors](/product/alerts/alert-types/#number-of-errors)\n- `eventTypes`: Any of `error` or `default`.\n```json\n{\n    \"queryType\": 0,\n    \"dataset\": \"events\",\n    \"aggregate\": \"count()\",\n    \"eventTypes\": [\"error\", \"default\"]\n}\n```\n\n### [Users Experiencing Errors](/product/alerts/alert-types/#users-experiencing-errors)\n- `eventTypes`: Any of `error` or `default`.\n```json\n{\n    \"queryType\": 0,\n    \"dataset\": \"events\",\n    \"aggregate\": \"count_unique(user)\"\n}\n```\n\n### [Crash Free Session Rate](/product/alerts/alert-types/#crash-free-session-rate)\n```json\n{\n    \"queryType\": 2,\n    \"dataset\": \"metrics\",\n    \"aggregate\": \"percentage(sessions_crashed, sessions) AS _crash_rate_alert_aggregate\"\n}\n```\n\n### [Crash Free User Rate](/product/alerts/alert-types/#crash-free-user-rate)\n```json\n{\n    \"queryType\": 2,\n    \"dataset\": \"metrics\",\n    \"aggregate\": \"percentage(users_crashed, users) AS _crash_rate_alert_aggregate\"\n}\n```\n\n### [Throughput](/product/alerts/alert-types/#throughput)\n```json\n{\n    \"queryType\": 1,\n    \"dataset\": \"transactions\",\n    \"aggregate\": \"count()\"\n}\n```\n\n### [Transaction Duration](/product/alerts/alert-types/#transaction-duration)\n-  `dataset`: If a custom percentile is used, `dataset` is `transactions`. Otherwise, `dataset` is `generic_metrics`.\n-  `aggregate`: Valid values are `avg(transaction.duration)`, `p50(transaction.duration)`, `p75(transaction.duration)`, `p95(transaction.duration)`, `p99(transaction.duration)`, `p100(transaction.duration)`, and `percentile(transaction.duration,x)`, where `x` is your custom percentile.\n```json\n{\n    \"queryType\": 1,\n    \"dataset\": \"generic_metrics\",\n    \"aggregate\": \"avg(transaction.duration)\"\n}\n```\n\n### [Apdex](/product/alerts/alert-types/#apdex)\n- `aggregate`: `apdex(x)` where `x` is the value of the Apdex score.\n```json\n{\n    \"queryType\": 1,\n    \"dataset\": \"transactions\",\n    \"aggregate\": \"apdex(300)\"\n}\n```\n\n### [Failure Rate](/product/alerts/alert-types/#failure-rate)\n```json\n{\n    \"queryType\": 1,\n    \"dataset\": \"transactions\",\n    \"aggregate\": \"failure_rate()\"\n}\n```\n\n### [Largest Contentful Paint](/product/alerts/alert-types/#largest-contentful-display)\n- `dataset`: If a custom percentile is used, `dataset` is `transactions`. Otherwise, `dataset` is `generic_metrics`.\n- `aggregate`: Valid values are `avg(measurements.lcp)`, `p50(measurements.lcp)`, `p75(measurements.lcp)`, `p95(measurements.lcp)`, `p99(measurements.lcp)`, `p100(measurements.lcp)`, and `percentile(measurements.lcp,x)`, where `x` is your custom percentile.\n```json\n{\n    \"queryType\": 1,\n    \"dataset\": \"generic_metrics\",\n    \"aggregate\": \"p50(measurements.lcp)\"\n}\n```\n\n### [First Input Delay](/product/alerts/alert-types/#first-input-delay)\n- `dataset`: If a custom percentile is used, `dataset` is `transactions`. Otherwise, `dataset` is `generic_metrics`.\n- `aggregate`: Valid values are `avg(measurements.fid)`, `p50(measurements.fid)`, `p75(measurements.fid)`, `p95(measurements.fid)`, `p99(measurements.fid)`, `p100(measurements.fid)`, and `percentile(measurements.fid,x)`, where `x` is your custom percentile.\n```json\n{\n    \"queryType\": 1,\n    \"dataset\": \"generic_metrics\",\n    \"aggregate\": \"p100(measurements.fid)\"\n}\n```\n\n### [Cumulative Layout Shift](/product/alerts/alert-types/#cumulative-layout-shift)\n- `dataset`: If a custom percentile is used, `dataset` is `transactions`. Otherwise, `dataset` is `generic_metrics`.\n- `aggregate`: Valid values are `avg(measurements.cls)`, `p50(measurements.cls)`, `p75(measurements.cls)`, `p95(measurements.cls)`, `p99(measurements.cls)`, `p100(measurements.cls)`, and `percentile(measurements.cls,x)`, where `x` is your custom percentile.\n```json\n{\n    \"queryType\": 1,\n    \"dataset\": \"transactions\",\n    \"aggregate\": \"percentile(measurements.cls,0.2)\"\n}\n```\n\n### [Custom Metric](/product/alerts/alert-types/#custom-metric)\n- `dataset`: If a custom percentile is used, `dataset` is `transactions`. Otherwise, `dataset` is `generic_metrics`.\n- `aggregate`: Valid values are:\n    - `avg(x)`, where `x` is `transaction.duration`, `measurements.cls`, `measurements.fcp`, `measurements.fid`, `measurements.fp`, `measurements.lcp`, `measurements.ttfb`, or `measurements.ttfb.requesttime`.\n    - `p50(x)`, where `x` is `transaction.duration`, `measurements.cls`, `measurements.fcp`, `measurements.fid`, `measurements.fp`, `measurements.lcp`, `measurements.ttfb`, or `measurements.ttfb.requesttime`.\n    - `p75(x)`, where `x` is `transaction.duration`, `measurements.cls`, `measurements.fcp`, `measurements.fid`, `measurements.fp`, `measurements.lcp`, `measurements.ttfb`, or `measurements.ttfb.requesttime`.\n    - `p95(x)`, where `x` is `transaction.duration`, `measurements.cls`, `measurements.fcp`, `measurements.fid`, `measurements.fp`, `measurements.lcp`, `measurements.ttfb`, or `measurements.ttfb.requesttime`.\n    - `p99(x)`, where `x` is `transaction.duration`, `measurements.cls`, `measurements.fcp`, `measurements.fid`, `measurements.fp`, `measurements.lcp`, `measurements.ttfb`, or `measurements.ttfb.requesttime`.\n    - `p100(x)`, where `x` is `transaction.duration`, `measurements.cls`, `measurements.fcp`, `measurements.fid`, `measurements.fp`, `measurements.lcp`, `measurements.ttfb`, or `measurements.ttfb.requesttime`.\n    - `percentile(x,y)`, where `x` is `transaction.duration`, `measurements.cls`, `measurements.fcp`, `measurements.fid`, `measurements.fp`, `measurements.lcp`, `measurements.ttfb`, or `measurements.ttfb.requesttime`, and `y` is the custom percentile.\n    - `failure_rate()`\n    - `apdex(x)`, where `x` is the value of the Apdex score.\n    - `count()`\n```json\n{\n    \"queryType\": 1,\n    \"dataset\": \"generic_metrics\",\n    \"aggregate\": \"p75(measurements.ttfb)\"\n}\n```",
    "pathParams": [
      "organization_id_or_slug"
    ],
    "queryParams": [],
    "deprecated": true,
    "resource": "alert-rules",
    "operationId": "(DEPRECATED) Create a Metric Alert Rule for an Organization"
  },
  {
    "fn": "deprecatedDeleteAMetricAlertRule",
    "method": "DELETE",
    "path": "/api/0/organizations/{organization_id_or_slug}/alert-rules/{alert_rule_id}/",
    "description": "## Deprecated\n 🚧 Use [Delete a Monitor](/api/monitors/delete-a-monitor) and [Delete an Alert](/api/monitors/delete-an-alert) instead.\n\n Delete a specific metric alert rule.\n\n A metric alert rule is a configuration that defines the conditions for triggering an alert.\n It specifies the metric type, function, time interval, and threshold\n values that determine when an alert should be triggered. Metric alert rules are used to monitor\n and notify you when certain metrics, like error count, latency, or failure rate, cross a\n predefined threshold. These rules help you proactively identify and address issues in your\n project.",
    "pathParams": [
      "organization_id_or_slug",
      "alert_rule_id"
    ],
    "queryParams": [],
    "deprecated": true,
    "resource": "alert-rules",
    "operationId": "(DEPRECATED) Delete a Metric Alert Rule"
  },
  {
    "fn": "deprecatedListAnOrganization_sMetricAlertRules",
    "method": "GET",
    "path": "/api/0/organizations/{organization_id_or_slug}/alert-rules/",
    "description": "## Deprecated\n🚧 Use [Fetch an Organization's Monitors](/api/monitors/fetch-an-organizations-monitors) and [Fetch Alerts](/api/monitors/fetch-alerts) instead.\n\n\nReturn a list of active metric alert rules bound to an organization.\n\nA metric alert rule is a configuration that defines the conditions for triggering an alert.\nIt specifies the metric type, function, time interval, and threshold\nvalues that determine when an alert should be triggered. Metric alert rules are used to monitor\nand notify you when certain metrics, like error count, latency, or failure rate, cross a\npredefined threshold. These rules help you proactively identify and address issues in your\nproject.",
    "pathParams": [
      "organization_id_or_slug"
    ],
    "queryParams": [],
    "deprecated": true,
    "resource": "alert-rules",
    "operationId": "(DEPRECATED) List an Organization's Metric Alert Rules"
  },
  {
    "fn": "deprecatedRetrieveAMetricAlertRuleForAnOrganization",
    "method": "GET",
    "path": "/api/0/organizations/{organization_id_or_slug}/alert-rules/{alert_rule_id}/",
    "description": "## Deprecated\n🚧 Use [Fetch a Monitor](/api/monitors/fetch-a-monitor) and [Fetch an Alert](/api/monitors/fetch-an-alert) instead.\n\n\nReturn details on an individual metric alert rule.\n\nA metric alert rule is a configuration that defines the conditions for triggering an alert.\nIt specifies the metric type, function, time interval, and threshold\nvalues that determine when an alert should be triggered. Metric alert rules are used to monitor\nand notify you when certain metrics, like error count, latency, or failure rate, cross a\npredefined threshold. These rules help you proactively identify and address issues in your\nproject.",
    "pathParams": [
      "organization_id_or_slug",
      "alert_rule_id"
    ],
    "queryParams": [],
    "deprecated": true,
    "resource": "alert-rules",
    "operationId": "(DEPRECATED) Retrieve a Metric Alert Rule for an Organization"
  },
  {
    "fn": "deprecatedUpdateAMetricAlertRule",
    "method": "PUT",
    "path": "/api/0/organizations/{organization_id_or_slug}/alert-rules/{alert_rule_id}/",
    "description": "## Deprecated\n🚧 Use [Update a Monitor by ID](/api/monitors/update-a-monitor-by-id) and [Update an Alert by ID](/api/monitors/update-an-alert-by-id) instead.\n\n\nUpdates a metric alert rule. See **Metric Alert Rule Types** under\n[Create a Metric Alert Rule for an Organization](/api/alerts/create-a-metric-alert-rule-for-an-organization/#metric-alert-rule-types)\nto see valid request body configurations for different types of metric alert rule types.\n> Warning: Calling this endpoint fully overwrites the specified metric alert.\n\nA metric alert rule is a configuration that defines the conditions for triggering an alert.\nIt specifies the metric type, function, time interval, and threshold\nvalues that determine when an alert should be triggered. Metric alert rules are used to monitor\nand notify you when certain metrics, like error count, latency, or failure rate, cross a\npredefined threshold. These rules help you proactively identify and address issues in your\nproject.",
    "pathParams": [
      "organization_id_or_slug",
      "alert_rule_id"
    ],
    "queryParams": [],
    "deprecated": true,
    "resource": "alert-rules",
    "operationId": "(DEPRECATED) Update a Metric Alert Rule"
  },
  {
    "fn": "retrieveSeerIssueFixState",
    "method": "GET",
    "path": "/api/0/organizations/{organization_id_or_slug}/issues/{issue_id}/autofix/",
    "description": "Retrieve the current detailed state of an issue fix process for a specific issue including:\n\n- Current status\n- Steps performed and their outcomes\n- Repository information and permissions\n- Root Cause Analysis\n- Proposed Solution\n- Generated code changes\n\nThis endpoint although documented is still experimental and the payload may change in the future.",
    "pathParams": [
      "organization_id_or_slug",
      "issue_id"
    ],
    "queryParams": [],
    "deprecated": false,
    "resource": "autofix",
    "operationId": "Retrieve Seer Issue Fix State"
  },
  {
    "fn": "startSeerIssueFix",
    "method": "POST",
    "path": "/api/0/organizations/{organization_id_or_slug}/issues/{issue_id}/autofix/",
    "description": "Trigger a Seer Issue Fix run for a specific issue.\n\nThe issue fix process can:\n- Identify the root cause of the issue\n- Propose a solution\n- Generate code changes\n- Create a pull request with the fix\n\nThe process runs asynchronously, and you can get the state using the GET endpoint.",
    "pathParams": [
      "organization_id_or_slug",
      "issue_id"
    ],
    "queryParams": [],
    "deprecated": false,
    "resource": "autofix",
    "operationId": "Start Seer Issue Fix"
  },
  {
    "fn": "retrievesListOfBranchesForAGivenOwnerAndRepository",
    "method": "GET",
    "path": "/api/0/organizations/{organization_id_or_slug}/prevent/owner/{owner}/repository/{repository}/branches/",
    "description": "Retrieves branch data for a given owner and repository.",
    "pathParams": [
      "organization_id_or_slug",
      "owner",
      "repository"
    ],
    "queryParams": [
      "limit",
      "navigation",
      "cursor",
      "term"
    ],
    "deprecated": false,
    "resource": "branches",
    "operationId": "Retrieves list of branches for a given owner and repository"
  },
  {
    "fn": "retrieveCheckInsForAMonitor",
    "method": "GET",
    "path": "/api/0/organizations/{organization_id_or_slug}/monitors/{monitor_id_or_slug}/checkins/",
    "description": "Retrieve a list of check-ins for a monitor",
    "pathParams": [
      "organization_id_or_slug",
      "monitor_id_or_slug"
    ],
    "queryParams": [
      "cursor"
    ],
    "deprecated": false,
    "resource": "checkins",
    "operationId": "Retrieve Check-Ins for a Monitor"
  },
  {
    "fn": "retrieveCheckInsForAMonitorByProject",
    "method": "GET",
    "path": "/api/0/projects/{organization_id_or_slug}/{project_id_or_slug}/monitors/{monitor_id_or_slug}/checkins/",
    "description": "Retrieve a list of check-ins for a monitor",
    "pathParams": [
      "organization_id_or_slug",
      "project_id_or_slug",
      "monitor_id_or_slug"
    ],
    "queryParams": [],
    "deprecated": false,
    "resource": "checkins",
    "operationId": "Retrieve Check-Ins for a Monitor by Project"
  },
  {
    "fn": "listClickedNodes",
    "method": "GET",
    "path": "/api/0/projects/{organization_id_or_slug}/{project_id_or_slug}/replays/{replay_id}/clicks/",
    "description": "Retrieve a collection of RRWeb DOM node-ids and the timestamp they were clicked.",
    "pathParams": [
      "organization_id_or_slug",
      "project_id_or_slug",
      "replay_id"
    ],
    "queryParams": [
      "cursor",
      "environment",
      "per_page",
      "query"
    ],
    "deprecated": false,
    "resource": "clicks",
    "operationId": "List Clicked Nodes"
  },
  {
    "fn": "retrieveFilesChangedInARelease_sCommits",
    "method": "GET",
    "path": "/api/0/organizations/{organization_id_or_slug}/releases/{version}/commitfiles/",
    "description": "Retrieve files changed in a release's commits",
    "pathParams": [
      "organization_id_or_slug",
      "version"
    ],
    "queryParams": [],
    "deprecated": false,
    "resource": "commitfiles",
    "operationId": "Retrieve Files Changed in a Release's Commits"
  },
  {
    "fn": "listAProjectRelease_sCommits",
    "method": "GET",
    "path": "/api/0/projects/{organization_id_or_slug}/{project_id_or_slug}/releases/{version}/commits/",
    "description": "List a project release's commits.",
    "pathParams": [
      "organization_id_or_slug",
      "project_id_or_slug",
      "version"
    ],
    "queryParams": [
      "cursor"
    ],
    "deprecated": false,
    "resource": "commits",
    "operationId": "List a Project Release's Commits"
  },
  {
    "fn": "listARepository_sCommits",
    "method": "GET",
    "path": "/api/0/organizations/{organization_id_or_slug}/repos/{repo_id}/commits/",
    "description": "List a Repository's Commits",
    "pathParams": [
      "organization_id_or_slug",
      "repo_id"
    ],
    "queryParams": [
      "cursor"
    ],
    "deprecated": false,
    "resource": "commits",
    "operationId": "List a Repository's Commits"
  },
  {
    "fn": "listAnOrganizationRelease_sCommits",
    "method": "GET",
    "path": "/api/0/organizations/{organization_id_or_slug}/releases/{version}/commits/",
    "description": "List an organization release's commits.",
    "pathParams": [
      "organization_id_or_slug",
      "version"
    ],
    "queryParams": [
      "cursor"
    ],
    "deprecated": false,
    "resource": "commits",
    "operationId": "List an Organization Release's Commits"
  },
  {
    "fn": "createANewDashboardForAnOrganization",
    "method": "POST",
    "path": "/api/0/organizations/{organization_id_or_slug}/dashboards/",
    "description": "Create a new dashboard for the given Organization",
    "pathParams": [
      "organization_id_or_slug"
    ],
    "queryParams": [],
    "deprecated": false,
    "resource": "dashboards",
    "operationId": "Create a New Dashboard for an Organization"
  },
  {
    "fn": "deleteAnOrganization_sCustomDashboard",
    "method": "DELETE",
    "path": "/api/0/organizations/{organization_id_or_slug}/dashboards/{dashboard_id}/",
    "description": "Delete an organization's custom dashboard, or tombstone\na pre-built dashboard which effectively deletes it.",
    "pathParams": [
      "organization_id_or_slug",
      "dashboard_id"
    ],
    "queryParams": [],
    "deprecated": false,
    "resource": "dashboards",
    "operationId": "Delete an Organization's Custom Dashboard"
  },
  {
    "fn": "editAnOrganization_sCustomDashboard",
    "method": "PUT",
    "path": "/api/0/organizations/{organization_id_or_slug}/dashboards/{dashboard_id}/",
    "description": "Edit an organization's custom dashboard as well as any bulk\nedits on widgets that may have been made. (For example, widgets\nthat have been rearranged, updated queries and fields, specific\ndisplay types, and so on.)",
    "pathParams": [
      "organization_id_or_slug",
      "dashboard_id"
    ],
    "queryParams": [],
    "deprecated": false,
    "resource": "dashboards",
    "operationId": "Edit an Organization's Custom Dashboard"
  },
  {
    "fn": "listAnOrganization_sCustomDashboards",
    "method": "GET",
    "path": "/api/0/organizations/{organization_id_or_slug}/dashboards/",
    "description": "Retrieve a list of custom dashboards that are associated with the given organization.",
    "pathParams": [
      "organization_id_or_slug"
    ],
    "queryParams": [
      "per_page",
      "cursor"
    ],
    "deprecated": false,
    "resource": "dashboards",
    "operationId": "List an Organization's Custom Dashboards"
  },
  {
    "fn": "retrieveAnOrganization_sCustomDashboard",
    "method": "GET",
    "path": "/api/0/organizations/{organization_id_or_slug}/dashboards/{dashboard_id}/",
    "description": "Return details about an organization's custom dashboard.",
    "pathParams": [
      "organization_id_or_slug",
      "dashboard_id"
    ],
    "queryParams": [],
    "deprecated": false,
    "resource": "dashboards",
    "operationId": "Retrieve an Organization's Custom Dashboard"
  },
  {
    "fn": "createReplayBatchDeletionJob",
    "method": "POST",
    "path": "/api/0/projects/{organization_id_or_slug}/{project_id_or_slug}/replays/jobs/delete/",
    "description": "Create a new replay deletion job.",
    "pathParams": [
      "organization_id_or_slug",
      "project_id_or_slug"
    ],
    "queryParams": [],
    "deprecated": false,
    "resource": "delete",
    "operationId": "Create Replay Batch Deletion Job"
  },
  {
    "fn": "listReplayBatchDeletionJobs",
    "method": "GET",
    "path": "/api/0/projects/{organization_id_or_slug}/{project_id_or_slug}/replays/jobs/delete/",
    "description": "Retrieve a collection of replay delete jobs.",
    "pathParams": [
      "organization_id_or_slug",
      "project_id_or_slug"
    ],
    "queryParams": [],
    "deprecated": false,
    "resource": "delete",
    "operationId": "List Replay Batch-Deletion Jobs"
  },
  {
    "fn": "retrieveAReplayBatchDeletionJob",
    "method": "GET",
    "path": "/api/0/projects/{organization_id_or_slug}/{project_id_or_slug}/replays/jobs/delete/{job_id}/",
    "description": "Fetch a replay delete job instance.",
    "pathParams": [
      "organization_id_or_slug",
      "project_id_or_slug",
      "job_id"
    ],
    "queryParams": [],
    "deprecated": false,
    "resource": "delete",
    "operationId": "Retrieve a Replay Batch-Deletion Job"
  },
  {
    "fn": "createADeploy",
    "method": "POST",
    "path": "/api/0/organizations/{organization_id_or_slug}/releases/{version}/deploys/",
    "description": "Create a deploy for a given release.",
    "pathParams": [
      "organization_id_or_slug",
      "version"
    ],
    "queryParams": [],
    "deprecated": false,
    "resource": "deploys",
    "operationId": "Create a Deploy"
  },
  {
    "fn": "listARelease_sDeploys",
    "method": "GET",
    "path": "/api/0/organizations/{organization_id_or_slug}/releases/{version}/deploys/",
    "description": "Returns a list of deploys based on the organization, version, and project.",
    "pathParams": [
      "organization_id_or_slug",
      "version"
    ],
    "queryParams": [
      "cursor"
    ],
    "deprecated": false,
    "resource": "deploys",
    "operationId": "List a Release's Deploys"
  },
  {
    "fn": "bulkDeleteMonitors",
    "method": "DELETE",
    "path": "/api/0/organizations/{organization_id_or_slug}/detectors/",
    "description": "⚠️ This endpoint is currently in **beta** and may be subject to change. It is supported by [New Monitors and Alerts](/product/new-monitors-and-alerts/) and may not be viewable in the UI today.\n\nBulk delete Monitors for a given organization",
    "pathParams": [
      "organization_id_or_slug"
    ],
    "queryParams": [
      "project",
      "query",
      "sortBy",
      "id"
    ],
    "deprecated": false,
    "resource": "detectors",
    "operationId": "Bulk Delete Monitors"
  },
  {
    "fn": "createAMonitorForAProject",
    "method": "POST",
    "path": "/api/0/organizations/{organization_id_or_slug}/detectors/",
    "description": "⚠️ This endpoint is currently in **beta** and may be subject to change. It is supported by [New Monitors and Alerts](/product/new-monitors-and-alerts/) and may not be viewable in the UI today.\n\nCreate a Monitor for a project",
    "pathParams": [
      "organization_id_or_slug"
    ],
    "queryParams": [],
    "deprecated": false,
    "resource": "detectors",
    "operationId": "Create a Monitor for a Project"
  },
  {
    "fn": "deleteAMonitor",
    "method": "DELETE",
    "path": "/api/0/organizations/{organization_id_or_slug}/detectors/{detector_id}/",
    "description": "⚠️ This endpoint is currently in **beta** and may be subject to change. It is supported by [New Monitors and Alerts](/product/new-monitors-and-alerts/) and may not be viewable in the UI today.\n\nDelete a monitor",
    "pathParams": [
      "organization_id_or_slug",
      "detector_id"
    ],
    "queryParams": [],
    "deprecated": false,
    "resource": "detectors",
    "operationId": "Delete a Monitor"
  },
  {
    "fn": "fetchAMonitor",
    "method": "GET",
    "path": "/api/0/organizations/{organization_id_or_slug}/detectors/{detector_id}/",
    "description": "⚠️ This endpoint is currently in **beta** and may be subject to change. It is supported by [New Monitors and Alerts](/product/new-monitors-and-alerts/) and may not be viewable in the UI today.\n\nReturn details on an individual monitor",
    "pathParams": [
      "organization_id_or_slug",
      "detector_id"
    ],
    "queryParams": [],
    "deprecated": false,
    "resource": "detectors",
    "operationId": "Fetch a Monitor"
  },
  {
    "fn": "fetchAnOrganization_sMonitors",
    "method": "GET",
    "path": "/api/0/organizations/{organization_id_or_slug}/detectors/",
    "description": "⚠️ This endpoint is currently in **beta** and may be subject to change. It is supported by [New Monitors and Alerts](/product/new-monitors-and-alerts/) and may not be viewable in the UI today.\n\nList an Organization's Monitors",
    "pathParams": [
      "organization_id_or_slug"
    ],
    "queryParams": [
      "project",
      "query",
      "sortBy",
      "id"
    ],
    "deprecated": false,
    "resource": "detectors",
    "operationId": "Fetch an Organization's Monitors"
  },
  {
    "fn": "mutateAnOrganization_sMonitors",
    "method": "PUT",
    "path": "/api/0/organizations/{organization_id_or_slug}/detectors/",
    "description": "⚠️ This endpoint is currently in **beta** and may be subject to change. It is supported by [New Monitors and Alerts](/product/new-monitors-and-alerts/) and may not be viewable in the UI today.\n\nBulk enable or disable an Organization's Monitors",
    "pathParams": [
      "organization_id_or_slug"
    ],
    "queryParams": [
      "project",
      "query",
      "id"
    ],
    "deprecated": false,
    "resource": "detectors",
    "operationId": "Mutate an Organization's Monitors"
  },
  {
    "fn": "updateAMonitorById",
    "method": "PUT",
    "path": "/api/0/organizations/{organization_id_or_slug}/detectors/{detector_id}/",
    "description": "⚠️ This endpoint is currently in **beta** and may be subject to change. It is supported by [New Monitors and Alerts](/product/new-monitors-and-alerts/) and may not be viewable in the UI today.\n\nUpdate an existing monitor",
    "pathParams": [
      "organization_id_or_slug",
      "detector_id"
    ],
    "queryParams": [],
    "deprecated": false,
    "resource": "detectors",
    "operationId": "Update a Monitor by ID"
  },
  {
    "fn": "deleteASpecificProject_sDebugInformationFile",
    "method": "DELETE",
    "path": "/api/0/projects/{organization_id_or_slug}/{project_id_or_slug}/files/dsyms/",
    "description": "Delete a debug information file for a given project.",
    "pathParams": [
      "organization_id_or_slug",
      "project_id_or_slug"
    ],
    "queryParams": [
      "id"
    ],
    "deprecated": false,
    "resource": "dsyms",
    "operationId": "Delete a Specific Project's Debug Information File"
  },
  {
    "fn": "listAProject_sDebugInformationFiles",
    "method": "GET",
    "path": "/api/0/projects/{organization_id_or_slug}/{project_id_or_slug}/files/dsyms/",
    "description": "Retrieve a list of debug information files for a given project.",
    "pathParams": [
      "organization_id_or_slug",
      "project_id_or_slug"
    ],
    "queryParams": [],
    "deprecated": false,
    "resource": "dsyms",
    "operationId": "List a Project's Debug Information Files"
  },
  {
    "fn": "uploadANewFile",
    "method": "POST",
    "path": "/api/0/projects/{organization_id_or_slug}/{project_id_or_slug}/files/dsyms/",
    "description": "Upload a new debug information file for the given release.\n\nUnlike other API requests, files must be uploaded using the\ntraditional multipart/form-data content-type.\n\nRequests to this endpoint should use the region-specific domain eg. `us.sentry.io` or `de.sentry.io`.\n\nThe file uploaded is a zip archive of an Apple .dSYM folder which\ncontains the individual debug images.  Uploading through this endpoint\nwill create different files for the contained images.",
    "pathParams": [
      "organization_id_or_slug",
      "project_id_or_slug"
    ],
    "queryParams": [],
    "deprecated": false,
    "resource": "dsyms",
    "operationId": "Upload a New File"
  },
  {
    "fn": "listAProject_sEnvironments",
    "method": "GET",
    "path": "/api/0/projects/{organization_id_or_slug}/{project_id_or_slug}/environments/",
    "description": "Lists a project's environments.",
    "pathParams": [
      "organization_id_or_slug",
      "project_id_or_slug"
    ],
    "queryParams": [
      "visibility"
    ],
    "deprecated": false,
    "resource": "environments",
    "operationId": "List a Project's Environments"
  },
  {
    "fn": "listAnOrganization_sEnvironments",
    "method": "GET",
    "path": "/api/0/organizations/{organization_id_or_slug}/environments/",
    "description": "Lists an organization's environments.",
    "pathParams": [
      "organization_id_or_slug"
    ],
    "queryParams": [
      "visibility"
    ],
    "deprecated": false,
    "resource": "environments",
    "operationId": "List an Organization's Environments"
  },
  {
    "fn": "retrieveAProjectEnvironment",
    "method": "GET",
    "path": "/api/0/projects/{organization_id_or_slug}/{project_id_or_slug}/environments/{environment}/",
    "description": "Return details on a project environment.",
    "pathParams": [
      "organization_id_or_slug",
      "project_id_or_slug",
      "environment"
    ],
    "queryParams": [],
    "deprecated": false,
    "resource": "environments",
    "operationId": "Retrieve a Project Environment"
  },
  {
    "fn": "updateAProjectEnvironment",
    "method": "PUT",
    "path": "/api/0/projects/{organization_id_or_slug}/{project_id_or_slug}/environments/{environment}/",
    "description": "Update the visibility for a project environment.",
    "pathParams": [
      "organization_id_or_slug",
      "project_id_or_slug",
      "environment"
    ],
    "queryParams": [],
    "deprecated": false,
    "resource": "environments",
    "operationId": "Update a Project Environment"
  },
  {
    "fn": "resolveAnEventId",
    "method": "GET",
    "path": "/api/0/organizations/{organization_id_or_slug}/eventids/{event_id}/",
    "description": "This resolves an event ID to the project slug and internal issue ID and internal event ID.",
    "pathParams": [
      "organization_id_or_slug",
      "event_id"
    ],
    "queryParams": [],
    "deprecated": false,
    "resource": "eventids",
    "operationId": "Resolve an Event ID"
  },
  {
    "fn": "listAProject_sErrorEvents",
    "method": "GET",
    "path": "/api/0/projects/{organization_id_or_slug}/{project_id_or_slug}/events/",
    "description": "Return a list of events bound to a project.",
    "pathParams": [
      "organization_id_or_slug",
      "project_id_or_slug"
    ],
    "queryParams": [
      "statsPeriod",
      "start",
      "end",
      "cursor",
      "full",
      "sample"
    ],
    "deprecated": false,
    "resource": "events",
    "operationId": "List a Project's Error Events"
  },
  {
    "fn": "listAnIssue_sEvents",
    "method": "GET",
    "path": "/api/0/organizations/{organization_id_or_slug}/issues/{issue_id}/events/",
    "description": "Return a list of error events bound to an issue",
    "pathParams": [
      "organization_id_or_slug",
      "issue_id"
    ],
    "queryParams": [
      "start",
      "end",
      "statsPeriod",
      "environment",
      "full",
      "sample",
      "query",
      "cursor"
    ],
    "deprecated": false,
    "resource": "events",
    "operationId": "List an Issue's Events"
  },
  {
    "fn": "queryExploreEventsInTableFormat",
    "method": "GET",
    "path": "/api/0/organizations/{organization_id_or_slug}/events/",
    "description": "Retrieves explore data for a given organization.\n\n**Note**: This endpoint is intended to get a table of results, and is not for doing a full export of data sent to\nSentry.\n\nThe `field` query parameter determines what fields will be selected in the `data` and `meta` keys of the endpoint response.\n- The `data` key contains a list of results row by row that match the `query` made\n- The `meta` key contains information about the response, including the unit or type of the fields requested",
    "pathParams": [
      "organization_id_or_slug"
    ],
    "queryParams": [
      "field",
      "dataset",
      "end",
      "environment",
      "project",
      "start",
      "statsPeriod",
      "per_page",
      "query",
      "sort"
    ],
    "deprecated": false,
    "resource": "events",
    "operationId": "Query Explore Events in Table Format"
  },
  {
    "fn": "retrieveAnEventForAProject",
    "method": "GET",
    "path": "/api/0/projects/{organization_id_or_slug}/{project_id_or_slug}/events/{event_id}/",
    "description": "Return details on an individual event.",
    "pathParams": [
      "organization_id_or_slug",
      "project_id_or_slug",
      "event_id"
    ],
    "queryParams": [],
    "deprecated": false,
    "resource": "events",
    "operationId": "Retrieve an Event for a Project"
  },
  {
    "fn": "retrieveAnIssueEvent",
    "method": "GET",
    "path": "/api/0/organizations/{organization_id_or_slug}/issues/{issue_id}/events/{event_id}/",
    "description": "Retrieves the details of an issue event.",
    "pathParams": [
      "organization_id_or_slug",
      "issue_id",
      "event_id"
    ],
    "queryParams": [
      "environment"
    ],
    "deprecated": false,
    "resource": "events",
    "operationId": "Retrieve an Issue Event"
  },
  {
    "fn": "queryExploreEventsInTimeseriesFormat",
    "method": "GET",
    "path": "/api/0/organizations/{organization_id_or_slug}/events-timeseries/",
    "description": "Retrieves explore data for a given organization as a timeseries.\n\nThis endpoint can return timeseries for either 1 or many axis, and results grouped to the top events depending\non the parameters passed",
    "pathParams": [
      "organization_id_or_slug"
    ],
    "queryParams": [
      "dataset",
      "end",
      "environment",
      "project",
      "start",
      "statsPeriod",
      "topEvents",
      "comparisonDelta",
      "interval",
      "sort",
      "groupBy",
      "yAxis",
      "query",
      "disableAggregateExtrapolation",
      "preventMetricAggregates",
      "excludeOther"
    ],
    "deprecated": false,
    "resource": "events-timeseries",
    "operationId": "Query Explore Events in Timeseries Format"
  },
  {
    "fn": "createOrUpdateAnExternalIssue",
    "method": "POST",
    "path": "/api/0/sentry-app-installations/{uuid}/external-issues/",
    "description": "Create or update an external issue from an integration platform integration.",
    "pathParams": [
      "uuid"
    ],
    "queryParams": [],
    "deprecated": false,
    "resource": "external-issues",
    "operationId": "Create or update an External Issue"
  },
  {
    "fn": "deleteAnExternalIssue",
    "method": "DELETE",
    "path": "/api/0/sentry-app-installations/{uuid}/external-issues/{external_issue_id}/",
    "description": "Delete an external issue.",
    "pathParams": [
      "uuid",
      "external_issue_id"
    ],
    "queryParams": [],
    "deprecated": false,
    "resource": "external-issues",
    "operationId": "Delete an External Issue"
  },
  {
    "fn": "retrieveCustomIntegrationIssueLinksForTheGivenSentryIssue",
    "method": "GET",
    "path": "/api/0/organizations/{organization_id_or_slug}/issues/{issue_id}/external-issues/",
    "description": "Retrieve custom integration issue links for the given Sentry issue",
    "pathParams": [
      "organization_id_or_slug",
      "issue_id"
    ],
    "queryParams": [],
    "deprecated": false,
    "resource": "external-issues",
    "operationId": "Retrieve custom integration issue links for the given Sentry issue"
  },
  {
    "fn": "createAnExternalTeam",
    "method": "POST",
    "path": "/api/0/teams/{organization_id_or_slug}/{team_id_or_slug}/external-teams/",
    "description": "Link a team from an external provider to a Sentry team.",
    "pathParams": [
      "organization_id_or_slug",
      "team_id_or_slug"
    ],
    "queryParams": [],
    "deprecated": false,
    "resource": "external-teams",
    "operationId": "Create an External Team"
  },
  {
    "fn": "deleteAnExternalTeam",
    "method": "DELETE",
    "path": "/api/0/teams/{organization_id_or_slug}/{team_id_or_slug}/external-teams/{external_team_id}/",
    "description": "Delete the link between a team from an external provider and a Sentry team.",
    "pathParams": [
      "organization_id_or_slug",
      "team_id_or_slug",
      "external_team_id"
    ],
    "queryParams": [],
    "deprecated": false,
    "resource": "external-teams",
    "operationId": "Delete an External Team"
  },
  {
    "fn": "updateAnExternalTeam",
    "method": "PUT",
    "path": "/api/0/teams/{organization_id_or_slug}/{team_id_or_slug}/external-teams/{external_team_id}/",
    "description": "Update a team in an external provider that is currently linked to a Sentry team.",
    "pathParams": [
      "organization_id_or_slug",
      "team_id_or_slug",
      "external_team_id"
    ],
    "queryParams": [],
    "deprecated": false,
    "resource": "external-teams",
    "operationId": "Update an External Team"
  },
  {
    "fn": "createAnExternalUser",
    "method": "POST",
    "path": "/api/0/organizations/{organization_id_or_slug}/external-users/",
    "description": "Link a user from an external provider to a Sentry user.",
    "pathParams": [
      "organization_id_or_slug"
    ],
    "queryParams": [],
    "deprecated": false,
    "resource": "external-users",
    "operationId": "Create an External User"
  },
  {
    "fn": "deleteAnExternalUser",
    "method": "DELETE",
    "path": "/api/0/organizations/{organization_id_or_slug}/external-users/{external_user_id}/",
    "description": "Delete the link between a user from an external provider and a Sentry user.",
    "pathParams": [
      "organization_id_or_slug",
      "external_user_id"
    ],
    "queryParams": [],
    "deprecated": false,
    "resource": "external-users",
    "operationId": "Delete an External User"
  },
  {
    "fn": "updateAnExternalUser",
    "method": "PUT",
    "path": "/api/0/organizations/{organization_id_or_slug}/external-users/{external_user_id}/",
    "description": "Update a user in an external provider that is currently linked to a Sentry user.",
    "pathParams": [
      "organization_id_or_slug",
      "external_user_id"
    ],
    "queryParams": [],
    "deprecated": false,
    "resource": "external-users",
    "operationId": "Update an External User"
  },
  {
    "fn": "deleteAProjectRelease_sFile",
    "method": "DELETE",
    "path": "/api/0/projects/{organization_id_or_slug}/{project_id_or_slug}/releases/{version}/files/{file_id}/",
    "description": "Delete a file for a given release.",
    "pathParams": [
      "organization_id_or_slug",
      "project_id_or_slug",
      "version",
      "file_id"
    ],
    "queryParams": [],
    "deprecated": false,
    "resource": "files",
    "operationId": "Delete a Project Release's File"
  },
  {
    "fn": "deleteAnOrganizationRelease_sFile",
    "method": "DELETE",
    "path": "/api/0/organizations/{organization_id_or_slug}/releases/{version}/files/{file_id}/",
    "description": "Delete a file for a given release.",
    "pathParams": [
      "organization_id_or_slug",
      "version",
      "file_id"
    ],
    "queryParams": [],
    "deprecated": false,
    "resource": "files",
    "operationId": "Delete an Organization Release's File"
  },
  {
    "fn": "listAProject_sReleaseFiles",
    "method": "GET",
    "path": "/api/0/projects/{organization_id_or_slug}/{project_id_or_slug}/releases/{version}/files/",
    "description": "Return a list of files for a given release.",
    "pathParams": [
      "organization_id_or_slug",
      "project_id_or_slug",
      "version"
    ],
    "queryParams": [
      "cursor"
    ],
    "deprecated": false,
    "resource": "files",
    "operationId": "List a Project's Release Files"
  },
  {
    "fn": "listAnOrganization_sReleaseFiles",
    "method": "GET",
    "path": "/api/0/organizations/{organization_id_or_slug}/releases/{version}/files/",
    "description": "Return a list of files for a given release.",
    "pathParams": [
      "organization_id_or_slug",
      "version"
    ],
    "queryParams": [
      "cursor"
    ],
    "deprecated": false,
    "resource": "files",
    "operationId": "List an Organization's Release Files"
  },
  {
    "fn": "retrieveAProjectRelease_sFile",
    "method": "GET",
    "path": "/api/0/projects/{organization_id_or_slug}/{project_id_or_slug}/releases/{version}/files/{file_id}/",
    "description": "Retrieve a file for a given release.",
    "pathParams": [
      "organization_id_or_slug",
      "project_id_or_slug",
      "version",
      "file_id"
    ],
    "queryParams": [
      "download"
    ],
    "deprecated": false,
    "resource": "files",
    "operationId": "Retrieve a Project Release's File"
  },
  {
    "fn": "retrieveAnOrganizationRelease_sFile",
    "method": "GET",
    "path": "/api/0/organizations/{organization_id_or_slug}/releases/{version}/files/{file_id}/",
    "description": "Retrieve a file for a given release.",
    "pathParams": [
      "organization_id_or_slug",
      "version",
      "file_id"
    ],
    "queryParams": [
      "download"
    ],
    "deprecated": false,
    "resource": "files",
    "operationId": "Retrieve an Organization Release's File"
  },
  {
    "fn": "updateAProjectReleaseFile",
    "method": "PUT",
    "path": "/api/0/projects/{organization_id_or_slug}/{project_id_or_slug}/releases/{version}/files/{file_id}/",
    "description": "Update a project release file.",
    "pathParams": [
      "organization_id_or_slug",
      "project_id_or_slug",
      "version",
      "file_id"
    ],
    "queryParams": [],
    "deprecated": false,
    "resource": "files",
    "operationId": "Update a Project Release File"
  },
  {
    "fn": "updateAnOrganizationReleaseFile",
    "method": "PUT",
    "path": "/api/0/organizations/{organization_id_or_slug}/releases/{version}/files/{file_id}/",
    "description": "Update an organization release file.",
    "pathParams": [
      "organization_id_or_slug",
      "version",
      "file_id"
    ],
    "queryParams": [],
    "deprecated": false,
    "resource": "files",
    "operationId": "Update an Organization Release File"
  },
  {
    "fn": "uploadANewOrganizationReleaseFile",
    "method": "POST",
    "path": "/api/0/organizations/{organization_id_or_slug}/releases/{version}/files/",
    "description": "Upload a new file for the given release.\n\nUnlike other API requests, files must be uploaded using the traditional multipart/form-data content-type.\n\nRequests to this endpoint should use the region-specific domain eg. `us.sentry.io` or `de.sentry.io`.\n\nThe optional 'name' attribute should reflect the absolute path that this file will be referenced as. For example, in the case of JavaScript you might specify the full web URI.",
    "pathParams": [
      "organization_id_or_slug",
      "version"
    ],
    "queryParams": [],
    "deprecated": false,
    "resource": "files",
    "operationId": "Upload a New Organization Release File"
  },
  {
    "fn": "uploadANewProjectReleaseFile",
    "method": "POST",
    "path": "/api/0/projects/{organization_id_or_slug}/{project_id_or_slug}/releases/{version}/files/",
    "description": "Upload a new file for the given release.\n\nUnlike other API requests, files must be uploaded using the traditional multipart/form-data content-type.\n\nRequests to this endpoint should use the region-specific domain eg. `us.sentry.io` or `de.sentry.io`\n\nThe optional 'name' attribute should reflect the absolute path that this file will be referenced as. For example, in the case of JavaScript you might specify the full web URI.",
    "pathParams": [
      "organization_id_or_slug",
      "project_id_or_slug",
      "version"
    ],
    "queryParams": [],
    "deprecated": false,
    "resource": "files",
    "operationId": "Upload a New Project Release File"
  },
  {
    "fn": "listAProject_sDataFilters",
    "method": "GET",
    "path": "/api/0/projects/{organization_id_or_slug}/{project_id_or_slug}/filters/",
    "description": "Retrieve a list of filters for a given project.\n`active` will be either a boolean or a list for the legacy browser filters.",
    "pathParams": [
      "organization_id_or_slug",
      "project_id_or_slug"
    ],
    "queryParams": [],
    "deprecated": false,
    "resource": "filters",
    "operationId": "List a Project's Data Filters"
  },
  {
    "fn": "updateAnInboundDataFilter",
    "method": "PUT",
    "path": "/api/0/projects/{organization_id_or_slug}/{project_id_or_slug}/filters/{filter_id}/",
    "description": "Update various inbound data filters for a project.",
    "pathParams": [
      "organization_id_or_slug",
      "project_id_or_slug",
      "filter_id"
    ],
    "queryParams": [],
    "deprecated": false,
    "resource": "filters",
    "operationId": "Update an Inbound Data Filter"
  },
  {
    "fn": "createADataForwarderForAnOrganization",
    "method": "POST",
    "path": "/api/0/organizations/{organization_id_or_slug}/forwarding/",
    "description": "Creates a new data forwarder for an organization.\nOnly one data forwarder can be created per provider for a given organization.\n\nProject-specific overrides can only be created after creating the data forwarder.",
    "pathParams": [
      "organization_id_or_slug"
    ],
    "queryParams": [],
    "deprecated": false,
    "resource": "forwarding",
    "operationId": "Create a Data Forwarder for an Organization"
  },
  {
    "fn": "deleteADataForwarderForAnOrganization",
    "method": "DELETE",
    "path": "/api/0/organizations/{organization_id_or_slug}/forwarding/{data_forwarder_id}/",
    "description": "Deletes a data forwarder for an organization. All project-specific overrides will be deleted as well.",
    "pathParams": [
      "organization_id_or_slug",
      "data_forwarder_id"
    ],
    "queryParams": [],
    "deprecated": false,
    "resource": "forwarding",
    "operationId": "Delete a Data Forwarder for an Organization"
  },
  {
    "fn": "retrieveDataForwardersForAnOrganization",
    "method": "GET",
    "path": "/api/0/organizations/{organization_id_or_slug}/forwarding/",
    "description": "Returns a list of data forwarders for an organization.",
    "pathParams": [
      "organization_id_or_slug"
    ],
    "queryParams": [],
    "deprecated": false,
    "resource": "forwarding",
    "operationId": "Retrieve Data Forwarders for an Organization"
  },
  {
    "fn": "updateADataForwarderForAnOrganization",
    "method": "PUT",
    "path": "/api/0/organizations/{organization_id_or_slug}/forwarding/{data_forwarder_id}/",
    "description": "Updates a data forwarder for an organization or update a project-specific override.\nUpdates to the data forwarder's configuration require `org:write` permissions, and the entire\nconfiguration to be provided, including the `project_ids` field.\n\nTo configure project-specific overrides, specify only the following fields:\n\n  - 'project_id': The ID of the project to create/modify the override for.\n  - 'overrides': Follows the same format as `config` but all provider fields are optional, since only specified fields are overridden.\n  - 'is_enabled': To enable/disable the forwarder for events on the specific project.\n\nOverrides can be performed with `project:write` permissions on the project being modified.",
    "pathParams": [
      "organization_id_or_slug",
      "data_forwarder_id"
    ],
    "queryParams": [],
    "deprecated": false,
    "resource": "forwarding",
    "operationId": "Update a Data Forwarder for an Organization"
  },
  {
    "fn": "deleteAnIndividualTeam",
    "method": "DELETE",
    "path": "/api/0/organizations/{organization_id_or_slug}/scim/v2/Groups/{team_id_or_slug}",
    "description": "Delete a team with a SCIM Group DELETE Request.",
    "pathParams": [
      "organization_id_or_slug",
      "team_id_or_slug"
    ],
    "queryParams": [],
    "deprecated": false,
    "resource": "Groups",
    "operationId": "Delete an Individual Team"
  },
  {
    "fn": "listAnOrganization_sPaginatedTeams",
    "method": "GET",
    "path": "/api/0/organizations/{organization_id_or_slug}/scim/v2/Groups",
    "description": "Returns a paginated list of teams bound to a organization with a SCIM Groups GET Request.\n\nNote that the members field will only contain up to 10,000 members.",
    "pathParams": [
      "organization_id_or_slug"
    ],
    "queryParams": [
      "startIndex",
      "count",
      "filter",
      "excludedAttributes"
    ],
    "deprecated": false,
    "resource": "Groups",
    "operationId": "List an Organization's Paginated Teams"
  },
  {
    "fn": "provisionANewTeam",
    "method": "POST",
    "path": "/api/0/organizations/{organization_id_or_slug}/scim/v2/Groups",
    "description": "Create a new team bound to an organization via a SCIM Groups POST\nRequest. The slug will have a normalization of uppercases/spaces to\nlowercases and dashes.\n\nNote that teams are always created with an empty member set.",
    "pathParams": [
      "organization_id_or_slug"
    ],
    "queryParams": [],
    "deprecated": false,
    "resource": "Groups",
    "operationId": "Provision a New Team"
  },
  {
    "fn": "queryAnIndividualTeam",
    "method": "GET",
    "path": "/api/0/organizations/{organization_id_or_slug}/scim/v2/Groups/{team_id_or_slug}",
    "description": "Query an individual team with a SCIM Group GET Request.\n- Note that the members field will only contain up to 10000 members.",
    "pathParams": [
      "organization_id_or_slug",
      "team_id_or_slug"
    ],
    "queryParams": [],
    "deprecated": false,
    "resource": "Groups",
    "operationId": "Query an Individual Team"
  },
  {
    "fn": "updateATeam_sAttributes",
    "method": "PATCH",
    "path": "/api/0/organizations/{organization_id_or_slug}/scim/v2/Groups/{team_id_or_slug}",
    "description": "Update a team's attributes with a SCIM Group PATCH Request.",
    "pathParams": [
      "organization_id_or_slug",
      "team_id_or_slug"
    ],
    "queryParams": [],
    "deprecated": false,
    "resource": "Groups",
    "operationId": "Update a Team's Attributes"
  },
  {
    "fn": "listAnIssue_sHashes",
    "method": "GET",
    "path": "/api/0/organizations/{organization_id_or_slug}/issues/{issue_id}/hashes/",
    "description": "This endpoint lists an issue's hashes, which are the generated checksums used to aggregate individual events.",
    "pathParams": [
      "organization_id_or_slug",
      "issue_id"
    ],
    "queryParams": [
      "full",
      "cursor"
    ],
    "deprecated": false,
    "resource": "hashes",
    "operationId": "List an Issue's Hashes"
  },
  {
    "fn": "listAProject_sServiceHooks",
    "method": "GET",
    "path": "/api/0/projects/{organization_id_or_slug}/{project_id_or_slug}/hooks/",
    "description": "Return a list of service hooks bound to a project.",
    "pathParams": [
      "organization_id_or_slug",
      "project_id_or_slug"
    ],
    "queryParams": [
      "cursor"
    ],
    "deprecated": false,
    "resource": "hooks",
    "operationId": "List a Project's Service Hooks"
  },
  {
    "fn": "registerANewServiceHook",
    "method": "POST",
    "path": "/api/0/projects/{organization_id_or_slug}/{project_id_or_slug}/hooks/",
    "description": "Register a new service hook on a project.\n\nEvents include:\n\n- event.alert: An alert is generated for an event (via rules).\n- event.created: A new event has been processed.\n\nThis endpoint requires the 'servicehooks' feature to be enabled for your project.",
    "pathParams": [
      "organization_id_or_slug",
      "project_id_or_slug"
    ],
    "queryParams": [],
    "deprecated": false,
    "resource": "hooks",
    "operationId": "Register a New Service Hook"
  },
  {
    "fn": "removeAServiceHook",
    "method": "DELETE",
    "path": "/api/0/projects/{organization_id_or_slug}/{project_id_or_slug}/hooks/{hook_id}/",
    "description": "Remove a service hook.",
    "pathParams": [
      "organization_id_or_slug",
      "project_id_or_slug",
      "hook_id"
    ],
    "queryParams": [],
    "deprecated": false,
    "resource": "hooks",
    "operationId": "Remove a Service Hook"
  },
  {
    "fn": "retrieveAServiceHook",
    "method": "GET",
    "path": "/api/0/projects/{organization_id_or_slug}/{project_id_or_slug}/hooks/{hook_id}/",
    "description": "Return a service hook bound to a project.",
    "pathParams": [
      "organization_id_or_slug",
      "project_id_or_slug",
      "hook_id"
    ],
    "queryParams": [],
    "deprecated": false,
    "resource": "hooks",
    "operationId": "Retrieve a Service Hook"
  },
  {
    "fn": "updateAServiceHook",
    "method": "PUT",
    "path": "/api/0/projects/{organization_id_or_slug}/{project_id_or_slug}/hooks/{hook_id}/",
    "description": "Update a service hook.",
    "pathParams": [
      "organization_id_or_slug",
      "project_id_or_slug",
      "hook_id"
    ],
    "queryParams": [],
    "deprecated": false,
    "resource": "hooks",
    "operationId": "Update a Service Hook"
  },
  {
    "fn": "retrieveInstallInfoForAGivenArtifact",
    "method": "GET",
    "path": "/api/0/organizations/{organization_id_or_slug}/preprodartifacts/{artifact_id}/install-details/",
    "description": "Retrieve install info for a given artifact.\n\nReturns distribution and installation details for a specific preprod artifact,\nincluding whether the artifact is installable, the install URL, download count,\nand iOS-specific code signing information.",
    "pathParams": [
      "organization_id_or_slug",
      "artifact_id"
    ],
    "queryParams": [],
    "deprecated": false,
    "resource": "install-details",
    "operationId": "Retrieve install info for a given artifact"
  },
  {
    "fn": "deleteAnIntegrationForAnOrganization",
    "method": "DELETE",
    "path": "/api/0/organizations/{organization_id_or_slug}/integrations/{integration_id}/",
    "description": "OrganizationIntegrationBaseEndpoints expect both Integration and\nOrganizationIntegration DB entries to exist for a given organization and\nintegration_id.",
    "pathParams": [
      "organization_id_or_slug",
      "integration_id"
    ],
    "queryParams": [],
    "deprecated": false,
    "resource": "integrations",
    "operationId": "Delete an Integration for an Organization"
  },
  {
    "fn": "getIntegrationProviderInformation",
    "method": "GET",
    "path": "/api/0/organizations/{organization_id_or_slug}/config/integrations/",
    "description": "Get integration provider information about all available integrations for an organization.",
    "pathParams": [
      "organization_id_or_slug"
    ],
    "queryParams": [
      "providerKey"
    ],
    "deprecated": false,
    "resource": "integrations",
    "operationId": "Get Integration Provider Information"
  },
  {
    "fn": "listAnOrganization_sAvailableIntegrations",
    "method": "GET",
    "path": "/api/0/organizations/{organization_id_or_slug}/integrations/",
    "description": "Lists all the available Integrations for an Organization.",
    "pathParams": [
      "organization_id_or_slug"
    ],
    "queryParams": [
      "providerKey",
      "features",
      "includeConfig",
      "cursor"
    ],
    "deprecated": false,
    "resource": "integrations",
    "operationId": "List an Organization's Available Integrations"
  },
  {
    "fn": "retrieveAnIntegrationForAnOrganization",
    "method": "GET",
    "path": "/api/0/organizations/{organization_id_or_slug}/integrations/{integration_id}/",
    "description": "OrganizationIntegrationBaseEndpoints expect both Integration and\nOrganizationIntegration DB entries to exist for a given organization and\nintegration_id.",
    "pathParams": [
      "organization_id_or_slug",
      "integration_id"
    ],
    "queryParams": [],
    "deprecated": false,
    "resource": "integrations",
    "operationId": "Retrieve an Integration for an Organization"
  },
  {
    "fn": "bulkMutateAListOfIssues",
    "method": "PUT",
    "path": "/api/0/projects/{organization_id_or_slug}/{project_id_or_slug}/issues/",
    "description": "Bulk mutate various attributes on issues.  The list of issues to modify is given through the `id` query parameter.  It is repeated for each issue that should be modified.\n\n- For non-status updates, the `id` query parameter is required.\n- For status updates, the `id` query parameter may be omitted\nfor a batch \"update all\" query.\n- An optional `status` query parameter may be used to restrict\nmutations to only events with the given status.\n\nThe following attributes can be modified and are supplied as JSON object in the body:\n\nIf any IDs are out of scope this operation will succeed without any data mutation.",
    "pathParams": [
      "organization_id_or_slug",
      "project_id_or_slug"
    ],
    "queryParams": [
      "id",
      "status"
    ],
    "deprecated": false,
    "resource": "issues",
    "operationId": "Bulk Mutate a List of Issues"
  },
  {
    "fn": "bulkMutateAnOrganization_sIssues",
    "method": "PUT",
    "path": "/api/0/organizations/{organization_id_or_slug}/issues/",
    "description": "Bulk mutate various attributes on a maxmimum of 1000 issues. \n- For non-status updates, the `id` query parameter is required. \n- For status updates, the `id` query parameter may be omitted to update issues that match the filtering. \nIf any IDs are out of scope, the data won't be mutated but the endpoint will still produce a successful response. For example, if no issues were found matching the criteria, a HTTP 204 is returned.",
    "pathParams": [
      "organization_id_or_slug"
    ],
    "queryParams": [
      "environment",
      "project",
      "id",
      "query",
      "viewId",
      "sort",
      "limit"
    ],
    "deprecated": false,
    "resource": "issues",
    "operationId": "Bulk Mutate an Organization's Issues"
  },
  {
    "fn": "bulkRemoveAListOfIssues",
    "method": "DELETE",
    "path": "/api/0/projects/{organization_id_or_slug}/{project_id_or_slug}/issues/",
    "description": "Permanently remove the given issues. The list of issues to modify is given through the `id` query parameter.  It is repeated for each issue that should be removed.\n\nOnly queries by 'id' are accepted.\n\nIf any IDs are out of scope this operation will succeed without any data mutation.",
    "pathParams": [
      "organization_id_or_slug",
      "project_id_or_slug"
    ],
    "queryParams": [
      "id"
    ],
    "deprecated": false,
    "resource": "issues",
    "operationId": "Bulk Remove a List of Issues"
  },
  {
    "fn": "bulkRemoveAnOrganization_sIssues",
    "method": "DELETE",
    "path": "/api/0/organizations/{organization_id_or_slug}/issues/",
    "description": "Permanently remove the given issues. If IDs are provided, queries and filtering will be ignored. If any IDs are out of scope, the data won't be mutated but the endpoint will still produce a successful response. For example, if no issues were found matching the criteria, a HTTP 204 is returned.",
    "pathParams": [
      "organization_id_or_slug"
    ],
    "queryParams": [
      "environment",
      "project",
      "id",
      "query",
      "viewId",
      "sort",
      "limit"
    ],
    "deprecated": false,
    "resource": "issues",
    "operationId": "Bulk Remove an Organization's Issues"
  },
  {
    "fn": "listAProject_sIssues",
    "method": "GET",
    "path": "/api/0/projects/{organization_id_or_slug}/{project_id_or_slug}/issues/",
    "description": "**Deprecated**: This endpoint has been replaced with the [Organization Issues endpoint](/api/events/list-an-organizations-issues/) which\nsupports filtering on project and additional functionality.\n\nReturn a list of issues (groups) bound to a project.  All parameters are supplied as query string parameters. \n\n A default query of ``is:unresolved`` is applied. To return results with other statuses send an new query value (i.e. ``?query=`` for all results).\n\nThe ``statsPeriod`` parameter can be used to select the timeline stats which should be present. Possible values are: ``\"\"`` (disable),``\"24h\"`` (default), ``\"14d\"``\n\nUser feedback items from the [User Feedback Widget](https://docs.sentry.io/product/user-feedback/#user-feedback-widget) are built off the issue platform, so to return a list of user feedback items for a specific project, filter for `issue.category:feedback`.",
    "pathParams": [
      "organization_id_or_slug",
      "project_id_or_slug"
    ],
    "queryParams": [
      "statsPeriod",
      "shortIdLookup",
      "query",
      "hashes",
      "cursor"
    ],
    "deprecated": false,
    "resource": "issues",
    "operationId": "List a Project's Issues"
  },
  {
    "fn": "listAnOrganization_sIssues",
    "method": "GET",
    "path": "/api/0/organizations/{organization_id_or_slug}/issues/",
    "description": "Return a list of issues for an organization. All parameters are supplied as query string parameters. A default query of `is:unresolved` is applied. To return all results, use an empty query value (i.e. ``?query=`).",
    "pathParams": [
      "organization_id_or_slug"
    ],
    "queryParams": [
      "environment",
      "project",
      "statsPeriod",
      "start",
      "end",
      "groupStatsPeriod",
      "shortIdLookup",
      "query",
      "viewId",
      "sort",
      "limit",
      "expand",
      "collapse",
      "cursor"
    ],
    "deprecated": false,
    "resource": "issues",
    "operationId": "List an Organization's Issues"
  },
  {
    "fn": "removeAnIssue",
    "method": "DELETE",
    "path": "/api/0/organizations/{organization_id_or_slug}/issues/{issue_id}/",
    "description": "Removes an individual issue.",
    "pathParams": [
      "organization_id_or_slug",
      "issue_id"
    ],
    "queryParams": [],
    "deprecated": false,
    "resource": "issues",
    "operationId": "Remove an Issue"
  },
  {
    "fn": "retrieveAnIssue",
    "method": "GET",
    "path": "/api/0/organizations/{organization_id_or_slug}/issues/{issue_id}/",
    "description": "Return details on an individual issue. This returns the basic stats for the issue (title, last seen, first seen), some overall numbers (number of comments, user reports) as well as the summarized event data.",
    "pathParams": [
      "organization_id_or_slug",
      "issue_id"
    ],
    "queryParams": [],
    "deprecated": false,
    "resource": "issues",
    "operationId": "Retrieve an Issue"
  },
  {
    "fn": "updateAnIssue",
    "method": "PUT",
    "path": "/api/0/organizations/{organization_id_or_slug}/issues/{issue_id}/",
    "description": "Updates an individual issue's attributes.  Only the attributes submitted are modified.",
    "pathParams": [
      "organization_id_or_slug",
      "issue_id"
    ],
    "queryParams": [],
    "deprecated": false,
    "resource": "issues",
    "operationId": "Update an Issue"
  },
  {
    "fn": "createANewClientKey",
    "method": "POST",
    "path": "/api/0/projects/{organization_id_or_slug}/{project_id_or_slug}/keys/",
    "description": "Create a new client key bound to a project.  The key's secret and public key\nare generated by the server.",
    "pathParams": [
      "organization_id_or_slug",
      "project_id_or_slug"
    ],
    "queryParams": [],
    "deprecated": false,
    "resource": "keys",
    "operationId": "Create a New Client Key"
  },
  {
    "fn": "deleteAClientKey",
    "method": "DELETE",
    "path": "/api/0/projects/{organization_id_or_slug}/{project_id_or_slug}/keys/{key_id}/",
    "description": "Delete a client key for a given project.",
    "pathParams": [
      "organization_id_or_slug",
      "project_id_or_slug",
      "key_id"
    ],
    "queryParams": [],
    "deprecated": false,
    "resource": "keys",
    "operationId": "Delete a Client Key"
  },
  {
    "fn": "listAProject_sClientKeys",
    "method": "GET",
    "path": "/api/0/projects/{organization_id_or_slug}/{project_id_or_slug}/keys/",
    "description": "Return a list of client keys bound to a project.",
    "pathParams": [
      "organization_id_or_slug",
      "project_id_or_slug"
    ],
    "queryParams": [
      "cursor",
      "status"
    ],
    "deprecated": false,
    "resource": "keys",
    "operationId": "List a Project's Client Keys"
  },
  {
    "fn": "retrieveAClientKey",
    "method": "GET",
    "path": "/api/0/projects/{organization_id_or_slug}/{project_id_or_slug}/keys/{key_id}/",
    "description": "Return a client key bound to a project.",
    "pathParams": [
      "organization_id_or_slug",
      "project_id_or_slug",
      "key_id"
    ],
    "queryParams": [],
    "deprecated": false,
    "resource": "keys",
    "operationId": "Retrieve a Client Key"
  },
  {
    "fn": "updateAClientKey",
    "method": "PUT",
    "path": "/api/0/projects/{organization_id_or_slug}/{project_id_or_slug}/keys/{key_id}/",
    "description": "Update various settings for a client key.",
    "pathParams": [
      "organization_id_or_slug",
      "project_id_or_slug",
      "key_id"
    ],
    "queryParams": [],
    "deprecated": false,
    "resource": "keys",
    "operationId": "Update a Client Key"
  },
  {
    "fn": "getTheLatestInstallableBuildForAProject",
    "method": "GET",
    "path": "/api/0/projects/{organization_id_or_slug}/{project_id_or_slug}/preprodartifacts/build-distribution/latest/",
    "description": "Get the latest installable build for a project.\n\nReturns the latest installable build matching filter criteria.\nWhen buildVersion is provided, also returns the current build and\nwhether an update is available.",
    "pathParams": [
      "organization_id_or_slug",
      "project_id_or_slug"
    ],
    "queryParams": [
      "appId",
      "platform",
      "buildVersion",
      "buildNumber",
      "mainBinaryIdentifier",
      "buildConfiguration",
      "codesigningType",
      "installGroups"
    ],
    "deprecated": false,
    "resource": "latest",
    "operationId": "Get the latest installable build for a project"
  },
  {
    "fn": "addAMemberToAnOrganization",
    "method": "POST",
    "path": "/api/0/organizations/{organization_id_or_slug}/members/",
    "description": "Add or invite a member to an organization.",
    "pathParams": [
      "organization_id_or_slug"
    ],
    "queryParams": [],
    "deprecated": false,
    "resource": "members",
    "operationId": "Add a Member to an Organization"
  },
  {
    "fn": "deleteAnOrganizationMember",
    "method": "DELETE",
    "path": "/api/0/organizations/{organization_id_or_slug}/members/{member_id}/",
    "description": "Remove an organization member.",
    "pathParams": [
      "organization_id_or_slug",
      "member_id"
    ],
    "queryParams": [],
    "deprecated": false,
    "resource": "members",
    "operationId": "Delete an Organization Member"
  },
  {
    "fn": "listAProject_sOrganizationMembers",
    "method": "GET",
    "path": "/api/0/projects/{organization_id_or_slug}/{project_id_or_slug}/members/",
    "description": "Returns a list of active organization members that belong to any team assigned to the project.",
    "pathParams": [
      "organization_id_or_slug",
      "project_id_or_slug"
    ],
    "queryParams": [],
    "deprecated": false,
    "resource": "members",
    "operationId": "List a Project's Organization Members"
  },
  {
    "fn": "listATeam_sMembers",
    "method": "GET",
    "path": "/api/0/teams/{organization_id_or_slug}/{team_id_or_slug}/members/",
    "description": "List all members on a team.\n\nThe response will not include members with pending invites.",
    "pathParams": [
      "organization_id_or_slug",
      "team_id_or_slug"
    ],
    "queryParams": [
      "cursor"
    ],
    "deprecated": false,
    "resource": "members",
    "operationId": "List a Team's Members"
  },
  {
    "fn": "listAnOrganization_sMembers",
    "method": "GET",
    "path": "/api/0/organizations/{organization_id_or_slug}/members/",
    "description": "List all organization members.\n\nResponse includes pending invites that are approved by organization owners or managers but waiting to be accepted by the invitee.",
    "pathParams": [
      "organization_id_or_slug"
    ],
    "queryParams": [
      "cursor"
    ],
    "deprecated": false,
    "resource": "members",
    "operationId": "List an Organization's Members"
  },
  {
    "fn": "retrieveAnOrganizationMember",
    "method": "GET",
    "path": "/api/0/organizations/{organization_id_or_slug}/members/{member_id}/",
    "description": "Retrieve an organization member's details.\n\nResponse will be a pending invite if it has been approved by organization owners or managers but is waiting to be accepted by the invitee.",
    "pathParams": [
      "organization_id_or_slug",
      "member_id"
    ],
    "queryParams": [],
    "deprecated": false,
    "resource": "members",
    "operationId": "Retrieve an Organization Member"
  },
  {
    "fn": "updateAnOrganizationMember_sRoles",
    "method": "PUT",
    "path": "/api/0/organizations/{organization_id_or_slug}/members/{member_id}/",
    "description": "Update a member's [organization-level](https://docs.sentry.io/organization/membership/#organization-level-roles) and [team-level](https://docs.sentry.io/organization/membership/#team-level-roles) roles.\n\nNote that for changing organization-roles, this endpoint is restricted to\n[user auth tokens](https://docs.sentry.io/account/auth-tokens/#user-auth-tokens).\nAdditionally, both the original and desired organization role must have\nthe same or lower permissions than the role of the organization user making the request\n\nFor example, an organization Manager may change someone's role from\nMember to Manager, but not to Owner.",
    "pathParams": [
      "organization_id_or_slug",
      "member_id"
    ],
    "queryParams": [],
    "deprecated": false,
    "resource": "members",
    "operationId": "Update an Organization Member's Roles"
  },
  {
    "fn": "listSeerAiModels",
    "method": "GET",
    "path": "/api/0/seer/models/",
    "description": "Get list of actively used LLM model names from Seer.\n\nReturns the list of AI models that are currently used in production in Seer.\nThis endpoint does not require authentication and can be used to discover which models Seer uses.\n\nRequests to this endpoint should use the region-specific domain\neg. `us.sentry.io` or `de.sentry.io`",
    "pathParams": [],
    "queryParams": [],
    "deprecated": false,
    "resource": "models",
    "operationId": "List Seer AI Models"
  },
  {
    "fn": "createAMonitor",
    "method": "POST",
    "path": "/api/0/organizations/{organization_id_or_slug}/monitors/",
    "description": "Create a new monitor.",
    "pathParams": [
      "organization_id_or_slug"
    ],
    "queryParams": [],
    "deprecated": false,
    "resource": "monitors",
    "operationId": "Create a Monitor"
  },
  {
    "fn": "deleteAMonitorOrMonitorEnvironments",
    "method": "DELETE",
    "path": "/api/0/organizations/{organization_id_or_slug}/monitors/{monitor_id_or_slug}/",
    "description": "Delete a monitor or monitor environments.",
    "pathParams": [
      "organization_id_or_slug",
      "monitor_id_or_slug"
    ],
    "queryParams": [
      "environment"
    ],
    "deprecated": false,
    "resource": "monitors",
    "operationId": "Delete a Monitor or Monitor Environments"
  },
  {
    "fn": "deleteAMonitorOrMonitorEnvironmentsForAProject",
    "method": "DELETE",
    "path": "/api/0/projects/{organization_id_or_slug}/{project_id_or_slug}/monitors/{monitor_id_or_slug}/",
    "description": "Delete a monitor or monitor environments.",
    "pathParams": [
      "organization_id_or_slug",
      "project_id_or_slug",
      "monitor_id_or_slug"
    ],
    "queryParams": [
      "environment"
    ],
    "deprecated": false,
    "resource": "monitors",
    "operationId": "Delete a Monitor or Monitor Environments for a Project"
  },
  {
    "fn": "retrieveAMonitor",
    "method": "GET",
    "path": "/api/0/organizations/{organization_id_or_slug}/monitors/{monitor_id_or_slug}/",
    "description": "Retrieves details for a monitor.",
    "pathParams": [
      "organization_id_or_slug",
      "monitor_id_or_slug"
    ],
    "queryParams": [
      "environment"
    ],
    "deprecated": false,
    "resource": "monitors",
    "operationId": "Retrieve a Monitor"
  },
  {
    "fn": "retrieveAMonitorForAProject",
    "method": "GET",
    "path": "/api/0/projects/{organization_id_or_slug}/{project_id_or_slug}/monitors/{monitor_id_or_slug}/",
    "description": "Retrieves details for a monitor.",
    "pathParams": [
      "organization_id_or_slug",
      "project_id_or_slug",
      "monitor_id_or_slug"
    ],
    "queryParams": [],
    "deprecated": false,
    "resource": "monitors",
    "operationId": "Retrieve a Monitor for a Project"
  },
  {
    "fn": "retrieveMonitorsForAnOrganization",
    "method": "GET",
    "path": "/api/0/organizations/{organization_id_or_slug}/monitors/",
    "description": "Lists monitors, including nested monitor environments. May be filtered to a project or environment.",
    "pathParams": [
      "organization_id_or_slug"
    ],
    "queryParams": [
      "project",
      "environment",
      "owner",
      "cursor"
    ],
    "deprecated": false,
    "resource": "monitors",
    "operationId": "Retrieve Monitors for an Organization"
  },
  {
    "fn": "updateAMonitor",
    "method": "PUT",
    "path": "/api/0/organizations/{organization_id_or_slug}/monitors/{monitor_id_or_slug}/",
    "description": "Update a monitor.",
    "pathParams": [
      "organization_id_or_slug",
      "monitor_id_or_slug"
    ],
    "queryParams": [],
    "deprecated": false,
    "resource": "monitors",
    "operationId": "Update a Monitor"
  },
  {
    "fn": "updateAMonitorForAProject",
    "method": "PUT",
    "path": "/api/0/projects/{organization_id_or_slug}/{project_id_or_slug}/monitors/{monitor_id_or_slug}/",
    "description": "Update a monitor.",
    "pathParams": [
      "organization_id_or_slug",
      "project_id_or_slug",
      "monitor_id_or_slug"
    ],
    "queryParams": [],
    "deprecated": false,
    "resource": "monitors",
    "operationId": "Update a Monitor for a Project"
  },
  {
    "fn": "listYourOrganizations",
    "method": "GET",
    "path": "/api/0/organizations/",
    "description": "Return a list of organizations available to the authenticated session in a region.\nThis is particularly useful for requests with a user bound context. For API key-based requests this will only return the organization that belongs to the key.",
    "pathParams": [],
    "queryParams": [
      "owner",
      "cursor",
      "query",
      "sortBy"
    ],
    "deprecated": false,
    "resource": "organizations",
    "operationId": "List Your Organizations"
  },
  {
    "fn": "retrieveAnOrganization",
    "method": "GET",
    "path": "/api/0/organizations/{organization_id_or_slug}/",
    "description": "Return details on an individual organization, including various details\nsuch as membership access and teams.",
    "pathParams": [
      "organization_id_or_slug"
    ],
    "queryParams": [
      "detailed"
    ],
    "deprecated": false,
    "resource": "organizations",
    "operationId": "Retrieve an Organization"
  },
  {
    "fn": "updateAnOrganization",
    "method": "PUT",
    "path": "/api/0/organizations/{organization_id_or_slug}/",
    "description": "Update various attributes and configurable settings for the given organization.",
    "pathParams": [
      "organization_id_or_slug"
    ],
    "queryParams": [],
    "deprecated": false,
    "resource": "organizations",
    "operationId": "Update an Organization"
  },
  {
    "fn": "retrieveOwnershipConfigurationForAProject",
    "method": "GET",
    "path": "/api/0/projects/{organization_id_or_slug}/{project_id_or_slug}/ownership/",
    "description": "Returns details on a project's ownership configuration.",
    "pathParams": [
      "organization_id_or_slug",
      "project_id_or_slug"
    ],
    "queryParams": [],
    "deprecated": false,
    "resource": "ownership",
    "operationId": "Retrieve Ownership Configuration for a Project"
  },
  {
    "fn": "updateOwnershipConfigurationForAProject",
    "method": "PUT",
    "path": "/api/0/projects/{organization_id_or_slug}/{project_id_or_slug}/ownership/",
    "description": "Updates ownership configurations for a project. Note that only the\nattributes submitted are modified.",
    "pathParams": [
      "organization_id_or_slug",
      "project_id_or_slug"
    ],
    "queryParams": [],
    "deprecated": false,
    "resource": "ownership",
    "operationId": "Update Ownership Configuration for a Project"
  },
  {
    "fn": "listAnOrganization_sClientKeys",
    "method": "GET",
    "path": "/api/0/organizations/{organization_id_or_slug}/project-keys/",
    "description": "Return a list of client keys (DSNs) for all projects in an organization.\n\nThis paginated endpoint lists client keys across all projects in an organization. Each key includes the project ID\nto identify which project it belongs to.\n\nQuery Parameters:\n- team: Filter by team slug or ID to get keys only for that team's projects\n- status: Filter by 'active' or 'inactive' to get keys with specific status",
    "pathParams": [
      "organization_id_or_slug"
    ],
    "queryParams": [
      "cursor",
      "team",
      "status"
    ],
    "deprecated": false,
    "resource": "project-keys",
    "operationId": "List an Organization's Client Keys"
  },
  {
    "fn": "createANewProject",
    "method": "POST",
    "path": "/api/0/teams/{organization_id_or_slug}/{team_id_or_slug}/projects/",
    "description": "Create a new project bound to a team.\n\n        Note: If your organization has disabled member project creation, the `org:write` or `team:admin` scope is required.",
    "pathParams": [
      "organization_id_or_slug",
      "team_id_or_slug"
    ],
    "queryParams": [],
    "deprecated": false,
    "resource": "projects",
    "operationId": "Create a New Project"
  },
  {
    "fn": "deleteAProject",
    "method": "DELETE",
    "path": "/api/0/projects/{organization_id_or_slug}/{project_id_or_slug}/",
    "description": "Schedules a project for deletion.\n\nDeletion happens asynchronously and therefore is not immediate. However once deletion has\nbegun the state of a project changes and will be hidden from most public views.",
    "pathParams": [
      "organization_id_or_slug",
      "project_id_or_slug"
    ],
    "queryParams": [],
    "deprecated": false,
    "resource": "projects",
    "operationId": "Delete a Project"
  },
  {
    "fn": "listATeam_sProjects",
    "method": "GET",
    "path": "/api/0/teams/{organization_id_or_slug}/{team_id_or_slug}/projects/",
    "description": "Return a list of projects bound to a team.",
    "pathParams": [
      "organization_id_or_slug",
      "team_id_or_slug"
    ],
    "queryParams": [
      "cursor"
    ],
    "deprecated": false,
    "resource": "projects",
    "operationId": "List a Team's Projects"
  },
  {
    "fn": "listAnOrganization_sProjects",
    "method": "GET",
    "path": "/api/0/organizations/{organization_id_or_slug}/projects/",
    "description": "Return a list of projects bound to a organization.",
    "pathParams": [
      "organization_id_or_slug"
    ],
    "queryParams": [
      "cursor"
    ],
    "deprecated": false,
    "resource": "projects",
    "operationId": "List an Organization's Projects"
  },
  {
    "fn": "retrieveAProject",
    "method": "GET",
    "path": "/api/0/projects/{organization_id_or_slug}/{project_id_or_slug}/",
    "description": "Return details on an individual project.",
    "pathParams": [
      "organization_id_or_slug",
      "project_id_or_slug"
    ],
    "queryParams": [],
    "deprecated": false,
    "resource": "projects",
    "operationId": "Retrieve a Project"
  },
  {
    "fn": "updateAProject",
    "method": "PUT",
    "path": "/api/0/projects/{organization_id_or_slug}/{project_id_or_slug}/",
    "description": "Update various attributes and configurable settings for the given project.\n\nNote that solely having the **`project:read`** scope restricts updatable settings to\n`isBookmarked`, `autofixAutomationTuning`, `seerScannerAutomation`,\n`preprodSizeStatusChecksEnabled`, `preprodSizeStatusChecksRules`,\n`preprodSizeEnabledQuery`, `preprodDistributionEnabledQuery`,\n`preprodSizeEnabledByCustomer`, `preprodDistributionEnabledByCustomer`,\nand `preprodDistributionPrCommentsEnabledByCustomer`.",
    "pathParams": [
      "organization_id_or_slug",
      "project_id_or_slug"
    ],
    "queryParams": [],
    "deprecated": false,
    "resource": "projects",
    "operationId": "Update a Project"
  },
  {
    "fn": "listRecordingSegments",
    "method": "GET",
    "path": "/api/0/projects/{organization_id_or_slug}/{project_id_or_slug}/replays/{replay_id}/recording-segments/",
    "description": "Return a collection of replay recording segments.",
    "pathParams": [
      "organization_id_or_slug",
      "project_id_or_slug",
      "replay_id"
    ],
    "queryParams": [
      "cursor",
      "per_page"
    ],
    "deprecated": false,
    "resource": "recording-segments",
    "operationId": "List Recording Segments"
  },
  {
    "fn": "retrieveARecordingSegment",
    "method": "GET",
    "path": "/api/0/projects/{organization_id_or_slug}/{project_id_or_slug}/replays/{replay_id}/recording-segments/{segment_id}/",
    "description": "Return a replay recording segment.",
    "pathParams": [
      "organization_id_or_slug",
      "project_id_or_slug",
      "replay_id",
      "segment_id"
    ],
    "queryParams": [],
    "deprecated": false,
    "resource": "recording-segments",
    "operationId": "Retrieve a Recording Segment"
  },
  {
    "fn": "regeneratesARepositoryUploadTokenAndReturnsTheNewToken",
    "method": "POST",
    "path": "/api/0/organizations/{organization_id_or_slug}/prevent/owner/{owner}/repository/{repository}/token/regenerate/",
    "description": "Regenerates a repository upload token and returns the new token.",
    "pathParams": [
      "organization_id_or_slug",
      "owner",
      "repository"
    ],
    "queryParams": [],
    "deprecated": false,
    "resource": "regenerate",
    "operationId": "Regenerates a repository upload token and returns the new token"
  },
  {
    "fn": "listAnOrganization_sTrustedRelays",
    "method": "GET",
    "path": "/api/0/organizations/{organization_id_or_slug}/relay_usage/",
    "description": "Return a list of trusted relays bound to an organization.",
    "pathParams": [
      "organization_id_or_slug"
    ],
    "queryParams": [],
    "deprecated": false,
    "resource": "relay_usage",
    "operationId": "List an Organization's trusted Relays"
  },
  {
    "fn": "retrieveStatusesOfReleaseThresholdsAlpha",
    "method": "GET",
    "path": "/api/0/organizations/{organization_id_or_slug}/release-threshold-statuses/",
    "description": "**`[WARNING]`**: This API is an experimental Alpha feature and is subject to change!\n\nList all derived statuses of releases that fall within the provided start/end datetimes.\n\nConstructs a response key'd off \\{`release_version`\\}-\\{`project_slug`\\} that lists thresholds with their status for *specified* projects.\nEach returned enriched threshold will contain the full serialized `release_threshold` instance as well as it's derived health statuses.",
    "pathParams": [
      "organization_id_or_slug"
    ],
    "queryParams": [
      "start",
      "end",
      "environment",
      "projectSlug",
      "release"
    ],
    "deprecated": false,
    "resource": "release-threshold-statuses",
    "operationId": "Retrieve Statuses of Release Thresholds (Alpha)"
  },
  {
    "fn": "createANewReleaseForAnOrganization",
    "method": "POST",
    "path": "/api/0/organizations/{organization_id_or_slug}/releases/",
    "description": "Create a new release for the given organization.  Releases are used by\nSentry to improve its error reporting abilities by correlating\nfirst seen events with the release that might have introduced the\nproblem.\nReleases are also necessary for source maps and other debug features\nthat require manual upload for functioning well.",
    "pathParams": [
      "organization_id_or_slug"
    ],
    "queryParams": [],
    "deprecated": false,
    "resource": "releases",
    "operationId": "Create a New Release for an Organization"
  },
  {
    "fn": "deleteAnOrganization_sRelease",
    "method": "DELETE",
    "path": "/api/0/organizations/{organization_id_or_slug}/releases/{version}/",
    "description": "Permanently remove a release and all of its files.",
    "pathParams": [
      "organization_id_or_slug",
      "version"
    ],
    "queryParams": [],
    "deprecated": false,
    "resource": "releases",
    "operationId": "Delete an Organization's Release"
  },
  {
    "fn": "listAnOrganization_sReleases",
    "method": "GET",
    "path": "/api/0/organizations/{organization_id_or_slug}/releases/",
    "description": "Return a list of releases for a given organization.",
    "pathParams": [
      "organization_id_or_slug"
    ],
    "queryParams": [
      "query",
      "cursor"
    ],
    "deprecated": false,
    "resource": "releases",
    "operationId": "List an Organization's Releases"
  },
  {
    "fn": "retrieveAnOrganization_sRelease",
    "method": "GET",
    "path": "/api/0/organizations/{organization_id_or_slug}/releases/{version}/",
    "description": "Return details on an individual release.",
    "pathParams": [
      "organization_id_or_slug",
      "version"
    ],
    "queryParams": [
      "project_id",
      "health",
      "adoptionStages",
      "summaryStatsPeriod",
      "healthStatsPeriod",
      "sort",
      "status",
      "query"
    ],
    "deprecated": false,
    "resource": "releases",
    "operationId": "Retrieve an Organization's Release"
  },
  {
    "fn": "updateAnOrganization_sRelease",
    "method": "PUT",
    "path": "/api/0/organizations/{organization_id_or_slug}/releases/{version}/",
    "description": "Update a release. This can change some metadata associated with\nthe release (the ref, url, and dates).",
    "pathParams": [
      "organization_id_or_slug",
      "version"
    ],
    "queryParams": [],
    "deprecated": false,
    "resource": "releases",
    "operationId": "Update an Organization's Release"
  },
  {
    "fn": "retrieveACountOfReplaysForAGivenIssueOrTransaction",
    "method": "GET",
    "path": "/api/0/organizations/{organization_id_or_slug}/replay-count/",
    "description": "Return a count of replays for a list of issue or transaction IDs.\n\nThe `query` parameter is required. It is a search query that includes exactly one of `issue.id`, `transaction`, or `replay_id` (string or list of strings).",
    "pathParams": [
      "organization_id_or_slug"
    ],
    "queryParams": [
      "environment",
      "start",
      "end",
      "statsPeriod",
      "project_id_or_slug",
      "query"
    ],
    "deprecated": false,
    "resource": "replay-count",
    "operationId": "Retrieve a Count of Replays for a Given Issue or Transaction"
  },
  {
    "fn": "listAnOrganization_sSelectors",
    "method": "GET",
    "path": "/api/0/organizations/{organization_id_or_slug}/replay-selectors/",
    "description": "Return a list of selectors for a given organization.",
    "pathParams": [
      "organization_id_or_slug"
    ],
    "queryParams": [
      "environment",
      "statsPeriod",
      "start",
      "end",
      "project",
      "projectSlug",
      "sort",
      "sortBy",
      "orderBy",
      "cursor",
      "per_page",
      "query"
    ],
    "deprecated": false,
    "resource": "replay-selectors",
    "operationId": "List an Organization's Selectors"
  },
  {
    "fn": "deleteAReplayInstance",
    "method": "DELETE",
    "path": "/api/0/projects/{organization_id_or_slug}/{project_id_or_slug}/replays/{replay_id}/",
    "description": "Delete a replay.",
    "pathParams": [
      "organization_id_or_slug",
      "project_id_or_slug",
      "replay_id"
    ],
    "queryParams": [],
    "deprecated": false,
    "resource": "replays",
    "operationId": "Delete a Replay Instance"
  },
  {
    "fn": "listAnOrganization_sReplays",
    "method": "GET",
    "path": "/api/0/organizations/{organization_id_or_slug}/replays/",
    "description": "Return a list of replays belonging to an organization.",
    "pathParams": [
      "organization_id_or_slug"
    ],
    "queryParams": [
      "statsPeriod",
      "start",
      "end",
      "field",
      "project",
      "projectSlug",
      "environment",
      "sort",
      "sortBy",
      "orderBy",
      "query",
      "per_page",
      "cursor"
    ],
    "deprecated": false,
    "resource": "replays",
    "operationId": "List an Organization's Replays"
  },
  {
    "fn": "retrieveAReplayInstance",
    "method": "GET",
    "path": "/api/0/organizations/{organization_id_or_slug}/replays/{replay_id}/",
    "description": "Return details on an individual replay.",
    "pathParams": [
      "organization_id_or_slug",
      "replay_id"
    ],
    "queryParams": [
      "statsPeriod",
      "start",
      "end",
      "field",
      "project",
      "projectSlug",
      "environment",
      "sort",
      "sortBy",
      "orderBy",
      "query",
      "per_page",
      "cursor"
    ],
    "deprecated": false,
    "resource": "replays",
    "operationId": "Retrieve a Replay Instance"
  },
  {
    "fn": "listAnOrganization_sRepositories",
    "method": "GET",
    "path": "/api/0/organizations/{organization_id_or_slug}/repos/",
    "description": "Return a list of version control repositories for a given organization.",
    "pathParams": [
      "organization_id_or_slug"
    ],
    "queryParams": [
      "cursor"
    ],
    "deprecated": false,
    "resource": "repos",
    "operationId": "List an Organization's Repositories"
  },
  {
    "fn": "retrievesListOfRepositoriesForAGivenOwner",
    "method": "GET",
    "path": "/api/0/organizations/{organization_id_or_slug}/prevent/owner/{owner}/repositories/",
    "description": "Retrieves repository data for a given owner.",
    "pathParams": [
      "organization_id_or_slug",
      "owner"
    ],
    "queryParams": [
      "limit",
      "navigation",
      "cursor",
      "term"
    ],
    "deprecated": false,
    "resource": "repositories",
    "operationId": "Retrieves list of repositories for a given owner"
  },
  {
    "fn": "retrievesASingleRepositoryForAGivenOwner",
    "method": "GET",
    "path": "/api/0/organizations/{organization_id_or_slug}/prevent/owner/{owner}/repository/{repository}/",
    "description": "Retrieves repository data for a single repository.",
    "pathParams": [
      "organization_id_or_slug",
      "owner",
      "repository"
    ],
    "queryParams": [],
    "deprecated": false,
    "resource": "repository",
    "operationId": "Retrieves a single repository for a given owner"
  },
  {
    "fn": "deprecatedCreateAnIssueAlertRuleForAProject",
    "method": "POST",
    "path": "/api/0/projects/{organization_id_or_slug}/{project_id_or_slug}/rules/",
    "description": "## Deprecated\n🚧 Use [Create a Monitor for a Project](/api/monitors/create-a-monitor-for-a-project) and [Create an Alert for an Organization](/api/monitors/create-an-alert-for-an-organization) instead.\n\n\nCreate a new issue alert rule for the given project.\n\nAn issue alert rule triggers whenever a new event is received for any issue in a project that matches the specified alert conditions. These conditions can include a resolved issue re-appearing or an issue affecting many users. Alert conditions have three parts:\n- Triggers: specify what type of activity you'd like monitored or when an alert should be triggered.\n- Filters: help control noise by triggering an alert only if the issue matches the specified criteria.\n- Actions: specify what should happen when the trigger conditions are met and the filters match.",
    "pathParams": [
      "organization_id_or_slug",
      "project_id_or_slug"
    ],
    "queryParams": [],
    "deprecated": true,
    "resource": "rules",
    "operationId": "(DEPRECATED) Create an Issue Alert Rule for a Project"
  },
  {
    "fn": "deprecatedDeleteAnIssueAlertRule",
    "method": "DELETE",
    "path": "/api/0/projects/{organization_id_or_slug}/{project_id_or_slug}/rules/{rule_id}/",
    "description": "## Deprecated\n 🚧 Use [Delete an Alert](/api/monitors/delete-an-alert) instead.\n\n\n Delete a specific issue alert rule.\n\n An issue alert rule triggers whenever a new event is received for any issue in a project that matches the specified alert conditions. These conditions can include a resolved issue re-appearing or an issue affecting many users. Alert conditions have three parts:\n - Triggers: specify what type of activity you'd like monitored or when an alert should be triggered.\n - Filters: help control noise by triggering an alert only if the issue matches the specified criteria.\n - Actions: specify what should happen when the trigger conditions are met and the filters match.",
    "pathParams": [
      "organization_id_or_slug",
      "project_id_or_slug",
      "rule_id"
    ],
    "queryParams": [],
    "deprecated": true,
    "resource": "rules",
    "operationId": "(DEPRECATED) Delete an Issue Alert Rule"
  },
  {
    "fn": "deprecatedListAProject_sIssueAlertRules",
    "method": "GET",
    "path": "/api/0/projects/{organization_id_or_slug}/{project_id_or_slug}/rules/",
    "description": "## Deprecated\n🚧 Use [Fetch an Organization's Monitors](/api/monitors/fetch-an-organizations-monitors) and [Fetch Alerts](/api/monitors/fetch-alerts) instead.\n\n\nReturn a list of active issue alert rules bound to a project.\n\nAn issue alert rule triggers whenever a new event is received for any issue in a project that matches the specified alert conditions. These conditions can include a resolved issue re-appearing or an issue affecting many users. Alert conditions have three parts:\n- Triggers: specify what type of activity you'd like monitored or when an alert should be triggered.\n- Filters: help control noise by triggering an alert only if the issue matches the specified criteria.\n- Actions: specify what should happen when the trigger conditions are met and the filters match.",
    "pathParams": [
      "organization_id_or_slug",
      "project_id_or_slug"
    ],
    "queryParams": [
      "cursor"
    ],
    "deprecated": true,
    "resource": "rules",
    "operationId": "(DEPRECATED) List a Project's Issue Alert Rules"
  },
  {
    "fn": "deprecatedRetrieveAnIssueAlertRuleForAProject",
    "method": "GET",
    "path": "/api/0/projects/{organization_id_or_slug}/{project_id_or_slug}/rules/{rule_id}/",
    "description": "## Deprecated\n🚧 Use [Fetch an Alert](/api/monitors/fetch-an-alert) instead.\n\n\nReturn details on an individual issue alert rule.\n\nAn issue alert rule triggers whenever a new event is received for any issue in a project that matches the specified alert conditions. These conditions can include a resolved issue re-appearing or an issue affecting many users. Alert conditions have three parts:\n- Triggers - specify what type of activity you'd like monitored or when an alert should be triggered.\n- Filters - help control noise by triggering an alert only if the issue matches the specified criteria.\n- Actions - specify what should happen when the trigger conditions are met and the filters match.",
    "pathParams": [
      "organization_id_or_slug",
      "project_id_or_slug",
      "rule_id"
    ],
    "queryParams": [],
    "deprecated": true,
    "resource": "rules",
    "operationId": "(DEPRECATED) Retrieve an Issue Alert Rule for a Project"
  },
  {
    "fn": "deprecatedUpdateAnIssueAlertRule",
    "method": "PUT",
    "path": "/api/0/projects/{organization_id_or_slug}/{project_id_or_slug}/rules/{rule_id}/",
    "description": "## Deprecated\n🚧 Use [Update an Alert by ID](/api/monitors/update-an-alert-by-id) instead.\n\n\nUpdates an issue alert rule.\n> Warning: Calling this endpoint fully overwrites the specified issue alert.\n\nAn issue alert rule triggers whenever a new event is received for any issue in a project that matches the specified alert conditions. These conditions can include a resolved issue re-appearing or an issue affecting many users. Alert conditions have three parts:\n- Triggers - specify what type of activity you'd like monitored or when an alert should be triggered.\n- Filters - help control noise by triggering an alert only if the issue matches the specified criteria.\n- Actions - specify what should happen when the trigger conditions are met and the filters match.",
    "pathParams": [
      "organization_id_or_slug",
      "project_id_or_slug",
      "rule_id"
    ],
    "queryParams": [],
    "deprecated": true,
    "resource": "rules",
    "operationId": "(DEPRECATED) Update an Issue Alert Rule"
  },
  {
    "fn": "createANewSavedQuery",
    "method": "POST",
    "path": "/api/0/organizations/{organization_id_or_slug}/discover/saved/",
    "description": "Create a new saved query for the given organization.",
    "pathParams": [
      "organization_id_or_slug"
    ],
    "queryParams": [],
    "deprecated": false,
    "resource": "saved",
    "operationId": "Create a New Saved Query"
  },
  {
    "fn": "deleteAnOrganization_sDiscoverSavedQuery",
    "method": "DELETE",
    "path": "/api/0/organizations/{organization_id_or_slug}/discover/saved/{query_id}/",
    "description": "Delete a saved query.",
    "pathParams": [
      "organization_id_or_slug",
      "query_id"
    ],
    "queryParams": [],
    "deprecated": false,
    "resource": "saved",
    "operationId": "Delete an Organization's Discover Saved Query"
  },
  {
    "fn": "editAnOrganization_sDiscoverSavedQuery",
    "method": "PUT",
    "path": "/api/0/organizations/{organization_id_or_slug}/discover/saved/{query_id}/",
    "description": "Modify a saved query.",
    "pathParams": [
      "organization_id_or_slug",
      "query_id"
    ],
    "queryParams": [],
    "deprecated": false,
    "resource": "saved",
    "operationId": "Edit an Organization's Discover Saved Query"
  },
  {
    "fn": "listAnOrganization_sDiscoverSavedQueries",
    "method": "GET",
    "path": "/api/0/organizations/{organization_id_or_slug}/discover/saved/",
    "description": "Retrieve a list of saved queries that are associated with the given organization.",
    "pathParams": [
      "organization_id_or_slug"
    ],
    "queryParams": [
      "per_page",
      "cursor",
      "query",
      "sortBy"
    ],
    "deprecated": false,
    "resource": "saved",
    "operationId": "List an Organization's Discover Saved Queries"
  },
  {
    "fn": "retrieveAnOrganization_sDiscoverSavedQuery",
    "method": "GET",
    "path": "/api/0/organizations/{organization_id_or_slug}/discover/saved/{query_id}/",
    "description": "Retrieve a saved query.",
    "pathParams": [
      "organization_id_or_slug",
      "query_id"
    ],
    "queryParams": [],
    "deprecated": false,
    "resource": "saved",
    "operationId": "Retrieve an Organization's Discover Saved Query"
  },
  {
    "fn": "listAnOrganization_sIntegrationPlatformInstallations",
    "method": "GET",
    "path": "/api/0/organizations/{organization_id_or_slug}/sentry-app-installations/",
    "description": "Return a list of integration platform installations for a given organization.",
    "pathParams": [
      "organization_id_or_slug"
    ],
    "queryParams": [
      "cursor"
    ],
    "deprecated": false,
    "resource": "sentry-app-installations",
    "operationId": "List an Organization's Integration Platform Installations"
  },
  {
    "fn": "deleteACustomIntegration",
    "method": "DELETE",
    "path": "/api/0/sentry-apps/{sentry_app_id_or_slug}/",
    "description": "Delete a custom integration.",
    "pathParams": [
      "sentry_app_id_or_slug"
    ],
    "queryParams": [],
    "deprecated": false,
    "resource": "sentry-apps",
    "operationId": "Delete a custom integration."
  },
  {
    "fn": "retrieveACustomIntegrationByIdOrSlug",
    "method": "GET",
    "path": "/api/0/sentry-apps/{sentry_app_id_or_slug}/",
    "description": "Retrieve a custom integration.",
    "pathParams": [
      "sentry_app_id_or_slug"
    ],
    "queryParams": [],
    "deprecated": false,
    "resource": "sentry-apps",
    "operationId": "Retrieve a custom integration by ID or slug."
  },
  {
    "fn": "retrieveTheCustomIntegrationsCreatedByAnOrganization",
    "method": "GET",
    "path": "/api/0/organizations/{organization_id_or_slug}/sentry-apps/",
    "description": "Retrieve the custom integrations for an organization",
    "pathParams": [
      "organization_id_or_slug"
    ],
    "queryParams": [],
    "deprecated": false,
    "resource": "sentry-apps",
    "operationId": "Retrieve the custom integrations created by an organization"
  },
  {
    "fn": "updateAnExistingCustomIntegration",
    "method": "PUT",
    "path": "/api/0/sentry-apps/{sentry_app_id_or_slug}/",
    "description": "Update an existing custom integration.",
    "pathParams": [
      "sentry_app_id_or_slug"
    ],
    "queryParams": [],
    "deprecated": false,
    "resource": "sentry-apps",
    "operationId": "Update an existing custom integration."
  },
  {
    "fn": "retrieveReleaseHealthSessionStatistics",
    "method": "GET",
    "path": "/api/0/organizations/{organization_id_or_slug}/sessions/",
    "description": "Returns a time series of release health session statistics for projects bound to an organization.\n\nThe interval and date range are subject to certain restrictions and rounding rules.\n\nThe date range is rounded to align with the interval, and is rounded to at least one\nhour. The interval can at most be one day and at least one hour currently. It has to cleanly\ndivide one day, for rounding reasons.\n\nBecause of technical limitations, this endpoint returns\nat most 10000 data points. For example, if you select a 90 day window grouped by releases,\nyou will see at most `floor(10k / (90 + 1)) = 109` releases. To get more results, reduce the\n`statsPeriod`.",
    "pathParams": [
      "organization_id_or_slug"
    ],
    "queryParams": [
      "field",
      "start",
      "end",
      "environment",
      "statsPeriod",
      "project",
      "per_page",
      "interval",
      "groupBy",
      "orderBy",
      "includeTotals",
      "includeSeries",
      "query"
    ],
    "deprecated": false,
    "resource": "sessions",
    "operationId": "Retrieve Release Health Session Statistics"
  },
  {
    "fn": "resolveAShortId",
    "method": "GET",
    "path": "/api/0/organizations/{organization_id_or_slug}/shortids/{issue_id}/",
    "description": "Resolve a short ID to the project slug and group details.",
    "pathParams": [
      "organization_id_or_slug",
      "issue_id"
    ],
    "queryParams": [],
    "deprecated": false,
    "resource": "shortids",
    "operationId": "Resolve a Short ID"
  },
  {
    "fn": "retrieveSizeAnalysisResultsForAGivenArtifact",
    "method": "GET",
    "path": "/api/0/organizations/{organization_id_or_slug}/preprodartifacts/{artifact_id}/size-analysis/",
    "description": "Retrieve size analysis results for a given artifact.\n\nReturns size metrics including download size, install size, and optional insights.\nWhen a base artifact exists (either from commit comparison or via the `baseArtifactId` parameter),\ncomparison data showing size differences is included.\n\nThe response `state` field indicates the analysis status:\n- `PENDING`: Analysis has not started yet.\n- `PROCESSING`: Analysis is currently running.\n- `FAILED` / `NOT_RAN`: Analysis did not complete; `errorCode` and `errorMessage` are included.\n- `COMPLETED`: Analysis finished successfully with full size data.",
    "pathParams": [
      "organization_id_or_slug",
      "artifact_id"
    ],
    "queryParams": [
      "baseArtifactId"
    ],
    "deprecated": false,
    "resource": "size-analysis",
    "operationId": "Retrieve Size Analysis results for a given artifact"
  },
  {
    "fn": "debugIssuesRelatedToSourceMapsForAGivenEvent",
    "method": "GET",
    "path": "/api/0/projects/{organization_id_or_slug}/{project_id_or_slug}/events/{event_id}/source-map-debug/",
    "description": "Return a list of source map errors for a given event.",
    "pathParams": [
      "organization_id_or_slug",
      "project_id_or_slug",
      "event_id"
    ],
    "queryParams": [
      "frame_idx",
      "exception_idx"
    ],
    "deprecated": false,
    "resource": "source-map-debug",
    "operationId": "Debug Issues Related to Source Maps for a Given Event"
  },
  {
    "fn": "disableSpikeProtection",
    "method": "DELETE",
    "path": "/api/0/organizations/{organization_id_or_slug}/spike-protections/",
    "description": "Disables Spike Protection feature for some of the projects within the organization.",
    "pathParams": [
      "organization_id_or_slug"
    ],
    "queryParams": [],
    "deprecated": false,
    "resource": "spike-protections",
    "operationId": "Disable Spike Protection"
  },
  {
    "fn": "enableSpikeProtection",
    "method": "POST",
    "path": "/api/0/organizations/{organization_id_or_slug}/spike-protections/",
    "description": "Enables Spike Protection feature for some of the projects within the organization.",
    "pathParams": [
      "organization_id_or_slug"
    ],
    "queryParams": [],
    "deprecated": false,
    "resource": "spike-protections",
    "operationId": "Enable Spike Protection"
  },
  {
    "fn": "retrieveEventCountsForAProject",
    "method": "GET",
    "path": "/api/0/projects/{organization_id_or_slug}/{project_id_or_slug}/stats/",
    "description": "Return a set of points representing a normalized timestamp and the\nnumber of events seen in the period.\n\nQuery ranges are limited to Sentry's configured time-series resolutions.",
    "pathParams": [
      "organization_id_or_slug",
      "project_id_or_slug"
    ],
    "queryParams": [
      "stat",
      "since",
      "until",
      "resolution"
    ],
    "deprecated": false,
    "resource": "stats",
    "operationId": "Retrieve Event Counts for a Project"
  },
  {
    "fn": "retrieveEventCountsForAnOrganizationV2",
    "method": "GET",
    "path": "/api/0/organizations/{organization_id_or_slug}/stats_v2/",
    "description": "Query event counts for your Organization.\nSelect a field, define a date range, and group or filter by columns.",
    "pathParams": [
      "organization_id_or_slug"
    ],
    "queryParams": [
      "groupBy",
      "field",
      "statsPeriod",
      "interval",
      "start",
      "end",
      "project",
      "category",
      "outcome",
      "reason"
    ],
    "deprecated": false,
    "resource": "stats_v2",
    "operationId": "Retrieve Event Counts for an Organization (v2)"
  },
  {
    "fn": "retrieveAnOrganization_sEventsCountByProject",
    "method": "GET",
    "path": "/api/0/organizations/{organization_id_or_slug}/stats-summary/",
    "description": "Query summarized event counts by project for your Organization. Also see https://docs.sentry.io/api/organizations/retrieve-event-counts-for-an-organization-v2/ for reference.",
    "pathParams": [
      "organization_id_or_slug"
    ],
    "queryParams": [
      "field",
      "statsPeriod",
      "interval",
      "start",
      "end",
      "project",
      "category",
      "outcome",
      "reason",
      "download"
    ],
    "deprecated": false,
    "resource": "stats-summary",
    "operationId": "Retrieve an Organization's Events Count by Project"
  },
  {
    "fn": "addASymbolSourceToAProject",
    "method": "POST",
    "path": "/api/0/projects/{organization_id_or_slug}/{project_id_or_slug}/symbol-sources/",
    "description": "Add a custom symbol source to a project.",
    "pathParams": [
      "organization_id_or_slug",
      "project_id_or_slug"
    ],
    "queryParams": [],
    "deprecated": false,
    "resource": "symbol-sources",
    "operationId": "Add a Symbol Source to a Project"
  },
  {
    "fn": "deleteASymbolSourceFromAProject",
    "method": "DELETE",
    "path": "/api/0/projects/{organization_id_or_slug}/{project_id_or_slug}/symbol-sources/",
    "description": "Delete a custom symbol source from a project.",
    "pathParams": [
      "organization_id_or_slug",
      "project_id_or_slug"
    ],
    "queryParams": [
      "id"
    ],
    "deprecated": false,
    "resource": "symbol-sources",
    "operationId": "Delete a Symbol Source from a Project"
  },
  {
    "fn": "retrieveAProject_sSymbolSources",
    "method": "GET",
    "path": "/api/0/projects/{organization_id_or_slug}/{project_id_or_slug}/symbol-sources/",
    "description": "List custom symbol sources configured for a project.",
    "pathParams": [
      "organization_id_or_slug",
      "project_id_or_slug"
    ],
    "queryParams": [
      "id"
    ],
    "deprecated": false,
    "resource": "symbol-sources",
    "operationId": "Retrieve a Project's Symbol Sources"
  },
  {
    "fn": "updateAProject_sSymbolSource",
    "method": "PUT",
    "path": "/api/0/projects/{organization_id_or_slug}/{project_id_or_slug}/symbol-sources/",
    "description": "Update a custom symbol source in a project.",
    "pathParams": [
      "organization_id_or_slug",
      "project_id_or_slug"
    ],
    "queryParams": [
      "id"
    ],
    "deprecated": false,
    "resource": "symbol-sources",
    "operationId": "Update a Project's Symbol Source"
  },
  {
    "fn": "getsSyncingStatusForRepositoriesForAnIntegratedOrg",
    "method": "GET",
    "path": "/api/0/organizations/{organization_id_or_slug}/prevent/owner/{owner}/repositories/sync/",
    "description": "Gets syncing status for repositories for an integrated organization.",
    "pathParams": [
      "organization_id_or_slug",
      "owner"
    ],
    "queryParams": [],
    "deprecated": false,
    "resource": "sync",
    "operationId": "Gets syncing status for repositories for an integrated org"
  },
  {
    "fn": "syncsRepositoriesFromAnIntegratedOrgWithGitHub",
    "method": "POST",
    "path": "/api/0/organizations/{organization_id_or_slug}/prevent/owner/{owner}/repositories/sync/",
    "description": "Syncs repositories for an integrated organization with GitHub.",
    "pathParams": [
      "organization_id_or_slug",
      "owner"
    ],
    "queryParams": [],
    "deprecated": false,
    "resource": "sync",
    "operationId": "Syncs repositories from an integrated org with GitHub"
  },
  {
    "fn": "retrieveTagDetails",
    "method": "GET",
    "path": "/api/0/organizations/{organization_id_or_slug}/issues/{issue_id}/tags/{key}/",
    "description": "Return a list of values associated with this key for an issue. When paginated can return at most 1000 values.",
    "pathParams": [
      "organization_id_or_slug",
      "issue_id",
      "key"
    ],
    "queryParams": [
      "environment"
    ],
    "deprecated": false,
    "resource": "tags",
    "operationId": "Retrieve Tag Details"
  },
  {
    "fn": "addATeamToAProject",
    "method": "POST",
    "path": "/api/0/projects/{organization_id_or_slug}/{project_id_or_slug}/teams/{team_id_or_slug}/",
    "description": "Give a team access to a project.",
    "pathParams": [
      "organization_id_or_slug",
      "project_id_or_slug",
      "team_id_or_slug"
    ],
    "queryParams": [],
    "deprecated": false,
    "resource": "teams",
    "operationId": "Add a Team to a Project"
  },
  {
    "fn": "addAnOrganizationMemberToATeam",
    "method": "POST",
    "path": "/api/0/organizations/{organization_id_or_slug}/members/{member_id}/teams/{team_id_or_slug}/",
    "description": "This request can return various success codes depending on the context of the team:\n- **`201`**: The member has been successfully added.\n- **`202`**: The member needs permission to join the team and an access request\nhas been generated.\n- **`204`**: The member is already on the team.\n\nIf the team is provisioned through an identity provider, the member cannot join the\nteam through Sentry.\n\nNote the permission scopes vary depending on the organization setting `\"Open Membership\"`\nand the type of authorization token. The following table outlines the accepted scopes.\n<table style=\"width: 100%;\">\n<thead>\n    <tr>\n    <th style=\"width: 33%;\"></th>\n    <th colspan=\"2\" style=\"text-align: center; font-weight: bold; width: 33%;\">Open Membership</th>\n    </tr>\n</thead>\n<tbody>\n    <tr>\n    <td style=\"width: 34%;\"></td>\n    <td style=\"text-align: center; font-weight: bold; width: 33%;\">On</td>\n    <td style=\"text-align: center; font-weight: bold; width: 33%;\">Off</td>\n    </tr>\n    <tr>\n    <td style=\"text-align: center; font-weight: bold; vertical-align: middle;\"><a\n    href=\"https://docs.sentry.io/account/auth-tokens/#internal-integrations\">Internal Integration Token</a></td>\n    <td style=\"text-align: left; width: 33%;\">\n        <ul style=\"list-style-type: none; padding-left: 0;\">\n        <li><strong style=\"color: #9c5f99;\">&bull; org:read</strong></li>\n        </ul>\n    </td>\n    <td style=\"text-align: left; width: 33%;\">\n        <ul style=\"list-style-type: none; padding-left: 0;\">\n        <li><strong style=\"color: #9c5f99;\">&bull; org:write</strong></li>\n        <li><strong style=\"color: #9c5f99;\">&bull; team:write</strong></li>\n        </ul>\n    </td>\n    </tr>\n    <tr>\n    <td style=\"text-align: center; font-weight: bold; vertical-align: middle;\"><a\n    href=\"https://docs.sentry.io/account/auth-tokens/#user-auth-tokens\">User Auth Token</a></td>\n    <td style=\"text-align: left; width: 33%;\">\n        <ul style=\"list-style-type: none; padding-left: 0;\">\n        <li><strong style=\"color: #9c5f99;\">&bull; org:read</strong></li>\n        </ul>\n    </td>\n    <td style=\"text-align: left; width: 33%;\">\n        <ul style=\"list-style-type: none; padding-left: 0;\">\n        <li><strong style=\"color: #9c5f99;\">&bull; org:read*</strong></li>\n        <li><strong style=\"color: #9c5f99;\">&bull; org:write</strong></li>\n        <li><strong style=\"color: #9c5f99;\">&bull; org:read +</strong></li>\n        <li><strong style=\"color: #9c5f99;\">&nbsp; &nbsp;team:write**</strong></li>\n        </ul>\n    </td>\n    </tr>\n</tbody>\n</table>\n\n\n*Organization members are restricted to this scope. When sending a request, it will always\nreturn a 202 and request an invite to the team.\n\n\n\\*\\*Team Admins must have both **`org:read`** and **`team:write`** scopes in their user\nauthorization token to add members to their teams.",
    "pathParams": [
      "organization_id_or_slug",
      "member_id",
      "team_id_or_slug"
    ],
    "queryParams": [],
    "deprecated": false,
    "resource": "teams",
    "operationId": "Add an Organization Member to a Team"
  },
  {
    "fn": "createANewTeam",
    "method": "POST",
    "path": "/api/0/organizations/{organization_id_or_slug}/teams/",
    "description": "Create a new team bound to an organization. Requires at least one of the `name`\nor `slug` body params to be set.",
    "pathParams": [
      "organization_id_or_slug"
    ],
    "queryParams": [],
    "deprecated": false,
    "resource": "teams",
    "operationId": "Create a New Team"
  },
  {
    "fn": "deleteATeam",
    "method": "DELETE",
    "path": "/api/0/teams/{organization_id_or_slug}/{team_id_or_slug}/",
    "description": "Schedules a team for deletion.\n\n**Note:** Deletion happens asynchronously and therefore is not\nimmediate. Teams will have their slug released while waiting for deletion.",
    "pathParams": [
      "organization_id_or_slug",
      "team_id_or_slug"
    ],
    "queryParams": [],
    "deprecated": false,
    "resource": "teams",
    "operationId": "Delete a Team"
  },
  {
    "fn": "deleteATeamFromAProject",
    "method": "DELETE",
    "path": "/api/0/projects/{organization_id_or_slug}/{project_id_or_slug}/teams/{team_id_or_slug}/",
    "description": "Revoke a team's access to a project.\n\nNote that Team Admins can only revoke access to teams they are admins of.",
    "pathParams": [
      "organization_id_or_slug",
      "project_id_or_slug",
      "team_id_or_slug"
    ],
    "queryParams": [],
    "deprecated": false,
    "resource": "teams",
    "operationId": "Delete a Team from a Project"
  },
  {
    "fn": "deleteAnOrganizationMemberFromATeam",
    "method": "DELETE",
    "path": "/api/0/organizations/{organization_id_or_slug}/members/{member_id}/teams/{team_id_or_slug}/",
    "description": "Delete an organization member from a team.\n\nNote the permission scopes vary depending on the type of authorization token. The following\ntable outlines the accepted scopes.\n<table style=\"width: 100%;\">\n    <tr style=\"width: 50%;\">\n        <td style=\"width: 50%; text-align: center; font-weight: bold; vertical-align: middle;\"><a href=\"https://docs.sentry.io/api/auth/#auth-tokens\">Org Auth Token</a></td>\n        <td style=\"width: 50%; text-align: left;\">\n            <ul style=\"list-style-type: none; padding-left: 0;\">\n                <li><strong style=\"color: #9c5f99;\">&bull; org:write</strong></li>\n                <li><strong style=\"color: #9c5f99;\">&bull; org:admin</strong></li>\n                <li><strong style=\"color: #9c5f99;\">&bull; team:admin</strong></li>\n            </ul>\n        </td>\n    </tr>\n    <tr style=\"width: 50%;\">\n        <td style=\"width: 50%; text-align: center; font-weight: bold; vertical-align: middle;\"><a href=\"https://docs.sentry.io/api/auth/#user-authentication-tokens\">User Auth Token</a></td>\n        <td style=\"width: 50%; text-align: left;\">\n            <ul style=\"list-style-type: none; padding-left: 0;\">\n                <li><strong style=\"color: #9c5f99;\">&bull; org:read*</strong></li>\n                <li><strong style=\"color: #9c5f99;\">&bull; org:write</strong></li>\n                <li><strong style=\"color: #9c5f99;\">&bull; org:admin</strong></li>\n                <li><strong style=\"color: #9c5f99;\">&bull; team:admin</strong></li>\n                <li><strong style=\"color: #9c5f99;\">&bull; org:read + team:admin**</strong></li>\n            </ul>\n        </td>\n    </tr>\n</table>\n\n\n\\***`org:read`** can only be used to remove yourself from the teams you are a member of.\n\n\n\\*\\*Team Admins must have both **`org:read`** and **`team:admin`** scopes in their user\nauthorization token to delete members from their teams.",
    "pathParams": [
      "organization_id_or_slug",
      "member_id",
      "team_id_or_slug"
    ],
    "queryParams": [],
    "deprecated": false,
    "resource": "teams",
    "operationId": "Delete an Organization Member from a Team"
  },
  {
    "fn": "listAProject_sTeams",
    "method": "GET",
    "path": "/api/0/projects/{organization_id_or_slug}/{project_id_or_slug}/teams/",
    "description": "Return a list of teams that have access to this project.",
    "pathParams": [
      "organization_id_or_slug",
      "project_id_or_slug"
    ],
    "queryParams": [
      "cursor"
    ],
    "deprecated": false,
    "resource": "teams",
    "operationId": "List a Project's Teams"
  },
  {
    "fn": "listAnOrganization_sTeams",
    "method": "GET",
    "path": "/api/0/organizations/{organization_id_or_slug}/teams/",
    "description": "Returns a list of teams bound to a organization.",
    "pathParams": [
      "organization_id_or_slug"
    ],
    "queryParams": [
      "detailed",
      "cursor"
    ],
    "deprecated": false,
    "resource": "teams",
    "operationId": "List an Organization's Teams"
  },
  {
    "fn": "retrieveATeam",
    "method": "GET",
    "path": "/api/0/teams/{organization_id_or_slug}/{team_id_or_slug}/",
    "description": "Return details on an individual team.",
    "pathParams": [
      "organization_id_or_slug",
      "team_id_or_slug"
    ],
    "queryParams": [
      "expand",
      "collapse"
    ],
    "deprecated": false,
    "resource": "teams",
    "operationId": "Retrieve a Team"
  },
  {
    "fn": "updateATeam",
    "method": "PUT",
    "path": "/api/0/teams/{organization_id_or_slug}/{team_id_or_slug}/",
    "description": "Update various attributes and configurable settings for the given\nteam.",
    "pathParams": [
      "organization_id_or_slug",
      "team_id_or_slug"
    ],
    "queryParams": [],
    "deprecated": false,
    "resource": "teams",
    "operationId": "Update a Team"
  },
  {
    "fn": "updateAnOrganizationMember_sTeamRole",
    "method": "PUT",
    "path": "/api/0/organizations/{organization_id_or_slug}/members/{member_id}/teams/{team_id_or_slug}/",
    "description": "The relevant organization member must already be a part of the team.\n\nNote that for organization admins, managers, and owners, they are\nautomatically granted a minimum team role of `admin` on all teams they\nare part of. Read more about [team roles](https://docs.sentry.io/product/teams/roles/).",
    "pathParams": [
      "organization_id_or_slug",
      "member_id",
      "team_id_or_slug"
    ],
    "queryParams": [],
    "deprecated": false,
    "resource": "teams",
    "operationId": "Update an Organization Member's Team Role"
  },
  {
    "fn": "retrievePaginatedListOfTestResultsForRepository_Owner_AndOrganization",
    "method": "GET",
    "path": "/api/0/organizations/{organization_id_or_slug}/prevent/owner/{owner}/repository/{repository}/test-results/",
    "description": "Retrieves the list of test results for a given repository and owner. Also accepts a number of query parameters to filter the results.",
    "pathParams": [
      "organization_id_or_slug",
      "owner",
      "repository"
    ],
    "queryParams": [
      "sortBy",
      "filterBy",
      "interval",
      "branch",
      "limit",
      "navigation",
      "cursor",
      "term"
    ],
    "deprecated": false,
    "resource": "test-results",
    "operationId": "Retrieve paginated list of test results for repository, owner, and organization"
  },
  {
    "fn": "retrieveAggregatedTestResultMetricsForRepository_Owner_AndOrganization",
    "method": "GET",
    "path": "/api/0/organizations/{organization_id_or_slug}/prevent/owner/{owner}/repository/{repository}/test-results-aggregates/",
    "description": "Retrieves aggregated test result metrics for a given repository and owner.\nAlso accepts a query parameter to specify the time period for the metrics.",
    "pathParams": [
      "organization_id_or_slug",
      "owner",
      "repository"
    ],
    "queryParams": [
      "interval",
      "branch"
    ],
    "deprecated": false,
    "resource": "test-results-aggregates",
    "operationId": "Retrieve aggregated test result metrics for repository, owner, and organization"
  },
  {
    "fn": "retrieveTestSuitesBelongingToARepository_sTestResults",
    "method": "GET",
    "path": "/api/0/organizations/{organization_id_or_slug}/prevent/owner/{owner}/repository/{repository}/test-suites/",
    "description": "Retrieves test suites belonging to a repository's test results.\nIt accepts a list of test suites as a query parameter to specify individual test suites.",
    "pathParams": [
      "organization_id_or_slug",
      "owner",
      "repository"
    ],
    "queryParams": [
      "term"
    ],
    "deprecated": false,
    "resource": "test-suites",
    "operationId": "Retrieve test suites belonging to a repository's test results"
  },
  {
    "fn": "retrievesAPaginatedListOfRepositoryTokensForAGivenOwner",
    "method": "GET",
    "path": "/api/0/organizations/{organization_id_or_slug}/prevent/owner/{owner}/repositories/tokens/",
    "description": "Retrieves a paginated list of repository tokens for a given owner.",
    "pathParams": [
      "organization_id_or_slug",
      "owner"
    ],
    "queryParams": [
      "limit",
      "navigation",
      "cursor",
      "sortBy"
    ],
    "deprecated": false,
    "resource": "tokens",
    "operationId": "Retrieves a paginated list of repository tokens for a given owner"
  },
  {
    "fn": "listAProject_sUserFeedback",
    "method": "GET",
    "path": "/api/0/projects/{organization_id_or_slug}/{project_id_or_slug}/user-feedback/",
    "description": "Return a list of user feedback items within this project.\n\n*This list does not include submissions from the [User Feedback Widget](https://docs.sentry.io/product/user-feedback/#user-feedback-widget). This is because it is based on an older format called User Reports - read more [here](https://develop.sentry.dev/application/feedback-architecture/#user-reports). To return a list of user feedback items from the widget, please use the [issue API](https://docs.sentry.io/api/events/list-a-projects-issues/) with the filter `issue.category:feedback`.*",
    "pathParams": [
      "organization_id_or_slug",
      "project_id_or_slug"
    ],
    "queryParams": [
      "cursor"
    ],
    "deprecated": false,
    "resource": "user-feedback",
    "operationId": "List a Project's User Feedback"
  },
  {
    "fn": "submitUserFeedback",
    "method": "POST",
    "path": "/api/0/projects/{organization_id_or_slug}/{project_id_or_slug}/user-feedback/",
    "description": "*This endpoint is DEPRECATED. We document it here for older SDKs and users who are still migrating to the [User Feedback Widget](https://docs.sentry.io/product/user-feedback/#user-feedback-widget) or [API](https://docs.sentry.io/platforms/javascript/user-feedback/#user-feedback-api)(multi-platform). If you are a new user, do not use this endpoint - unless you don't have a JS frontend, and your platform's SDK does not offer a feedback API.*\n\nFeedback must be received by the server no more than 30 minutes after the event was saved.\n\nAdditionally, within 5 minutes of submitting feedback it may also be overwritten. This is useful in situations where you may need to retry sending a request due to network failures.\n\nIf feedback is rejected due to a mutability threshold, a 409 status code will be returned.\n\nNote: Feedback may be submitted with DSN authentication (see auth documentation).",
    "pathParams": [
      "organization_id_or_slug",
      "project_id_or_slug"
    ],
    "queryParams": [],
    "deprecated": false,
    "resource": "user-feedback",
    "operationId": "Submit User Feedback"
  },
  {
    "fn": "listAUser_sTeamsForAnOrganization",
    "method": "GET",
    "path": "/api/0/organizations/{organization_id_or_slug}/user-teams/",
    "description": "Returns a list of teams the user has access to in the specified organization.\nNote that this endpoint is restricted to [user auth tokens](https://docs.sentry.io/account/auth-tokens/#user-auth-tokens).",
    "pathParams": [
      "organization_id_or_slug"
    ],
    "queryParams": [],
    "deprecated": false,
    "resource": "user-teams",
    "operationId": "List a User's Teams for an Organization"
  },
  {
    "fn": "listAProject_sUsers",
    "method": "GET",
    "path": "/api/0/projects/{organization_id_or_slug}/{project_id_or_slug}/users/",
    "description": "Return a list of users seen within this project.",
    "pathParams": [
      "organization_id_or_slug",
      "project_id_or_slug"
    ],
    "queryParams": [
      "query",
      "cursor"
    ],
    "deprecated": false,
    "resource": "users",
    "operationId": "List a Project's Users"
  },
  {
    "fn": "deleteAnOrganizationMemberViaScim",
    "method": "DELETE",
    "path": "/api/0/organizations/{organization_id_or_slug}/scim/v2/Users/{member_id}",
    "description": "Delete an organization member with a SCIM User DELETE Request.",
    "pathParams": [
      "organization_id_or_slug",
      "member_id"
    ],
    "queryParams": [],
    "deprecated": false,
    "resource": "Users",
    "operationId": "Delete an Organization Member via SCIM"
  },
  {
    "fn": "listAnOrganization_sScimMembers",
    "method": "GET",
    "path": "/api/0/organizations/{organization_id_or_slug}/scim/v2/Users",
    "description": "Returns a paginated list of members bound to a organization with a SCIM Users GET Request.",
    "pathParams": [
      "organization_id_or_slug"
    ],
    "queryParams": [
      "startIndex",
      "count",
      "filter",
      "excludedAttributes"
    ],
    "deprecated": false,
    "resource": "Users",
    "operationId": "List an Organization's SCIM Members"
  },
  {
    "fn": "provisionANewOrganizationMember",
    "method": "POST",
    "path": "/api/0/organizations/{organization_id_or_slug}/scim/v2/Users",
    "description": "Create a new Organization Member via a SCIM Users POST Request.\n\nNote that this API does not support setting secondary emails.",
    "pathParams": [
      "organization_id_or_slug"
    ],
    "queryParams": [],
    "deprecated": false,
    "resource": "Users",
    "operationId": "Provision a New Organization Member"
  },
  {
    "fn": "queryAnIndividualOrganizationMember",
    "method": "GET",
    "path": "/api/0/organizations/{organization_id_or_slug}/scim/v2/Users/{member_id}",
    "description": "Query an individual organization member with a SCIM User GET Request.\n- The `name` object will contain fields `firstName` and `lastName` with the values of `N/A`.\nSentry's SCIM API does not currently support these fields but returns them for compatibility purposes.",
    "pathParams": [
      "organization_id_or_slug",
      "member_id"
    ],
    "queryParams": [],
    "deprecated": false,
    "resource": "Users",
    "operationId": "Query an Individual Organization Member"
  },
  {
    "fn": "updateAnOrganizationMember_sAttributes",
    "method": "PATCH",
    "path": "/api/0/organizations/{organization_id_or_slug}/scim/v2/Users/{member_id}",
    "description": "Update an organization member's attributes with a SCIM PATCH Request.",
    "pathParams": [
      "organization_id_or_slug",
      "member_id"
    ],
    "queryParams": [],
    "deprecated": false,
    "resource": "Users",
    "operationId": "Update an Organization Member's Attributes"
  },
  {
    "fn": "listATag_sValues",
    "method": "GET",
    "path": "/api/0/projects/{organization_id_or_slug}/{project_id_or_slug}/tags/{key}/values/",
    "description": "Return a list of values associated with this key.  The `query`\nparameter can be used to to perform a \"contains\" match on\nvalues. \n\nWhen [paginated](/api/pagination) can return at most 1000 values.",
    "pathParams": [
      "organization_id_or_slug",
      "project_id_or_slug",
      "key"
    ],
    "queryParams": [
      "cursor"
    ],
    "deprecated": false,
    "resource": "values",
    "operationId": "List a Tag's Values"
  },
  {
    "fn": "listATag_sValuesForAnIssue",
    "method": "GET",
    "path": "/api/0/organizations/{organization_id_or_slug}/issues/{issue_id}/tags/{key}/values/",
    "description": "Returns a list of values associated with this key for an issue.\nReturns at most 1000 values when paginated.",
    "pathParams": [
      "organization_id_or_slug",
      "issue_id",
      "key"
    ],
    "queryParams": [
      "sort",
      "environment"
    ],
    "deprecated": false,
    "resource": "values",
    "operationId": "List a Tag's Values for an Issue"
  },
  {
    "fn": "listUsersWhoHaveViewedAReplay",
    "method": "GET",
    "path": "/api/0/projects/{organization_id_or_slug}/{project_id_or_slug}/replays/{replay_id}/viewed-by/",
    "description": "Return a list of users who have viewed a replay.",
    "pathParams": [
      "organization_id_or_slug",
      "project_id_or_slug",
      "replay_id"
    ],
    "queryParams": [],
    "deprecated": false,
    "resource": "viewed-by",
    "operationId": "List Users Who Have Viewed a Replay"
  },
  {
    "fn": "bulkDeleteAlerts",
    "method": "DELETE",
    "path": "/api/0/organizations/{organization_id_or_slug}/workflows/",
    "description": "⚠️ This endpoint is currently in **beta** and may be subject to change. It is supported by [New Monitors and Alerts](/product/new-monitors-and-alerts/) and may not be viewable in the UI today.\n\nBulk delete alerts for a given organization",
    "pathParams": [
      "organization_id_or_slug"
    ],
    "queryParams": [
      "query",
      "id",
      "project"
    ],
    "deprecated": false,
    "resource": "workflows",
    "operationId": "Bulk Delete Alerts"
  },
  {
    "fn": "createAnAlertForAnOrganization",
    "method": "POST",
    "path": "/api/0/organizations/{organization_id_or_slug}/workflows/",
    "description": "⚠️ This endpoint is currently in **beta** and may be subject to change. It is supported by [New Monitors and Alerts](/product/new-monitors-and-alerts/) and may not be viewable in the UI today.\n\nCreates an alert for an organization",
    "pathParams": [
      "organization_id_or_slug"
    ],
    "queryParams": [],
    "deprecated": false,
    "resource": "workflows",
    "operationId": "Create an Alert for an Organization"
  },
  {
    "fn": "deleteAnAlert",
    "method": "DELETE",
    "path": "/api/0/organizations/{organization_id_or_slug}/workflows/{workflow_id}/",
    "description": "⚠️ This endpoint is currently in **beta** and may be subject to change. It is supported by [New Monitors and Alerts](/product/new-monitors-and-alerts/) and may not be viewable in the UI today.\n\nDeletes an alert.",
    "pathParams": [
      "organization_id_or_slug",
      "workflow_id"
    ],
    "queryParams": [],
    "deprecated": false,
    "resource": "workflows",
    "operationId": "Delete an Alert"
  },
  {
    "fn": "fetchAlerts",
    "method": "GET",
    "path": "/api/0/organizations/{organization_id_or_slug}/workflows/",
    "description": "⚠️ This endpoint is currently in **beta** and may be subject to change. It is supported by [New Monitors and Alerts](/product/new-monitors-and-alerts/) and may not be viewable in the UI today.\n\nReturns a list of alerts for a given organization",
    "pathParams": [
      "organization_id_or_slug"
    ],
    "queryParams": [
      "sortBy",
      "query",
      "id",
      "project"
    ],
    "deprecated": false,
    "resource": "workflows",
    "operationId": "Fetch Alerts"
  },
  {
    "fn": "fetchAnAlert",
    "method": "GET",
    "path": "/api/0/organizations/{organization_id_or_slug}/workflows/{workflow_id}/",
    "description": "⚠️ This endpoint is currently in **beta** and may be subject to change. It is supported by [New Monitors and Alerts](/product/new-monitors-and-alerts/) and may not be viewable in the UI today.\n\nReturns an alert.",
    "pathParams": [
      "organization_id_or_slug",
      "workflow_id"
    ],
    "queryParams": [],
    "deprecated": false,
    "resource": "workflows",
    "operationId": "Fetch an Alert"
  },
  {
    "fn": "mutateAnOrganization_sAlerts",
    "method": "PUT",
    "path": "/api/0/organizations/{organization_id_or_slug}/workflows/",
    "description": "⚠️ This endpoint is currently in **beta** and may be subject to change. It is supported by [New Monitors and Alerts](/product/new-monitors-and-alerts/) and may not be viewable in the UI today.\n\nBulk enable or disable alerts for a given Organization",
    "pathParams": [
      "organization_id_or_slug"
    ],
    "queryParams": [
      "query",
      "id",
      "project"
    ],
    "deprecated": false,
    "resource": "workflows",
    "operationId": "Mutate an Organization's Alerts"
  },
  {
    "fn": "updateAnAlertById",
    "method": "PUT",
    "path": "/api/0/organizations/{organization_id_or_slug}/workflows/{workflow_id}/",
    "description": "⚠️ This endpoint is currently in **beta** and may be subject to change. It is supported by [New Monitors and Alerts](/product/new-monitors-and-alerts/) and may not be viewable in the UI today.\n\nUpdates an alert.",
    "pathParams": [
      "organization_id_or_slug",
      "workflow_id"
    ],
    "queryParams": [],
    "deprecated": false,
    "resource": "workflows",
    "operationId": "Update an Alert by ID"
  }
]